export function GoogleIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ? size : "24"}
      height={size ? size : "24"}
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect width="24" height="24" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.04 12.2614C23.04 11.4459 22.9668 10.6618 22.8309 9.90909H12V14.3575H18.1891C17.9225 15.795 17.1123 17.013 15.8943 17.8284V20.7139H19.6109C21.7855 18.7118 23.04 15.7636 23.04 12.2614Z"
        fill="#4285F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9995 23.4998C15.1045 23.4998 17.7077 22.4701 19.6104 20.7137L15.8938 17.8283C14.864 18.5183 13.5467 18.926 11.9995 18.926C9.00425 18.926 6.46902 16.903 5.5647 14.1848H1.72266V17.1644C3.61493 20.9228 7.50402 23.4998 11.9995 23.4998Z"
        fill="#34A853"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.56523 14.1851C5.33523 13.4951 5.20455 12.758 5.20455 12.0001C5.20455 11.2421 5.33523 10.5051 5.56523 9.81506V6.83551H1.72318C0.944318 8.38801 0.5 10.1444 0.5 12.0001C0.5 13.8557 0.944318 15.6121 1.72318 17.1646L5.56523 14.1851Z"
        fill="#FBBC05"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9995 5.07386C13.6879 5.07386 15.2038 5.65409 16.3956 6.79364L19.694 3.49523C17.7024 1.63955 15.0992 0.5 11.9995 0.5C7.50402 0.5 3.61493 3.07705 1.72266 6.83545L5.5647 9.815C6.46902 7.09682 9.00425 5.07386 11.9995 5.07386Z"
        fill="#EA4335"
      />
    </svg>
  );
}
export function PromoSVG({ size, color, title, children }) {
  return (
    <svg
      width="99"
      height="108"
      viewBox="0 0 99 108"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36.3201 55.9099V101.84L2.95996 36.6499L36.3201 55.9099Z"
        fill="#F3F3F3"
        stroke="#71717B"
      />
      <path
        d="M52.0701 13.5L32.0701 23.5L22.76 18.13L12.1501 12L32.1501 2L52.0701 13.5Z"
        fill="#D9D9D9"
        stroke="#71717B"
      />
      <path
        d="M32.0701 23.5L31.3101 24.8199L28.4399 29.8099L26.4001 33.36L22.01 40.99L9.14014 33.5599L2 29.4399L12.1501 12L22.76 18.13L32.0701 23.5Z"
        fill="#D9D9D9"
        stroke="#71717B"
      />
      <path
        d="M52.0701 13.5L46.3601 23.4301L38.6401 27.29L37.8701 28.6L34.9399 33.5699L34.1401 34.92V34.9301L28.6101 37.6899L22.01 40.99L26.4001 33.36L28.4399 29.8099L31.3101 24.8199L32.0701 23.5L52.0701 13.5Z"
        fill="#E9E9E9"
        stroke="#71717B"
      />
      <path
        d="M59.8 17.96L57.6001 19.0599L45.3501 25.1801V25.1899L39.8 27.96L38.6401 27.29L46.3601 23.4301L58.6401 17.29L59.8 17.96Z"
        stroke="#71717B"
      />
      <path
        d="M50.05 57.1801L48.3 56.17L42.5 52.8199L33.78 47.79L28.3901 44.6801L30.4199 41.23L34.1401 34.9301V34.92L34.9399 33.5699L37.8701 28.6L38.6401 27.29L39.8 27.96L40.5701 30.16L41.03 31.48L43.5 38.51L47.6201 50.26L49.49 55.58L50.05 57.1801Z"
        stroke="#71717B"
      />
      <path
        d="M53.8502 53.39L54.41 55L50.05 57.1801L49.4901 55.58L47.6201 50.26L43.5 38.51L41.03 31.48L40.5701 30.16L39.8 27.96L45.3502 25.1899V25.1801L57.6002 19.0599L59.8 17.96L61.9199 23.99L51.6699 29.11V29.12L46.3801 31.76L50.01 42.27L52.01 48.0599L53.8502 53.39Z"
        fill="#E0E0E0"
        stroke="#71717B"
      />
      <path
        d="M86.29 33.2598L72.7 40.0597L68.3201 42.2498L66.29 43.2598L49.1599 33.3698L46.3801 31.7598L51.6699 29.1198V29.1098L61.9199 23.9898L66.3801 21.7598L86.29 33.2598Z"
        fill="#D9D9D9"
        stroke="#71717B"
      />
      <path
        d="M95.48 68.52L62.1201 95.1899L42.1201 105.19L62.1201 89.2L75.48 78.52L95.48 68.52Z"
        stroke="#71717B"
      />
      <path
        d="M95.48 68.52L75.48 78.52L62.1201 70.8099L56.3201 67.46L42.1201 59.26L48.3 56.17L50.05 57.1801L54.4099 55L56.3201 60.54L56.4299 60.86L62.1201 64.15L76.45 72.42L90.27 65.51L95.48 68.52Z"
        fill="#E0E0E0"
        stroke="#71717B"
      />
      <path
        d="M75.48 78.5198L62.1201 89.1998L42.1201 105.19V59.2598L56.3201 67.4598L62.1201 70.8097L75.48 78.5198Z"
        fill="#E0E0E0"
        stroke="#71717B"
      />
      <path
        d="M48.3 56.1699L42.1201 59.2599V98.9398L36.3201 101.84V55.9099L37.6001 55.2699L42.5 52.8198L48.3 56.1699Z"
        fill="#F3F3F3"
        stroke="#71717B"
      />
      <path
        d="M42.5 52.8201L37.6001 55.2702L36.3201 55.9102L2.95996 36.6502L9.14014 33.5601L22.01 40.9902L28.6101 37.6901L34.1401 34.9303L30.4199 41.2302L28.3901 44.6803L33.78 47.7902L42.5 52.8201Z"
        fill="#E0E0E0"
        stroke="#71717B"
      />
      <path
        d="M76.45 72.4198L62.1201 64.1498L56.4299 60.8598L56.3201 60.5398L54.4099 54.9998L53.8501 53.3898L52.01 48.0597L50.01 42.2698L46.3801 31.7598L49.1599 33.3698L66.29 43.2598L67.05 45.4498L68.01 48.1998L69.96 53.7798L76.45 72.4198Z"
        fill="#D9D9D9"
        stroke="#71717B"
      />
      <path
        d="M96.45 62.4198L90.27 65.5098L76.45 72.4198L69.96 53.7798L68.01 48.1998L67.05 45.4498L66.29 43.2598L68.3201 42.2498L72.7 40.0597L86.29 33.2598L96.45 62.4198Z"
        fill="#D9D9D9"
        stroke="#71717B"
      />
    </svg>
  );
}
export function ArrowLeftIcon({ size, color, title, children, className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ? size : "24"}
      height={size ? size : "24"}
      viewBox="0 0 24 24"
      fill={color ? color : "none"}
      className={className}  // Add this line
    >
      <path
        d="M10 7L14 12L10 17"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function PhoneIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ? size : "24"}
      height={size ? size : "24"}
      viewBox="0 0 24 24"
      fill={color ? color : "none"}
    >
      <path
        d="M7.33464 24C7.33464 24 4.66797 24 4.66797 21.3333V2.66667C4.66797 2.66667 4.66797 0 7.33464 0H16.668C16.668 0 19.3346 0 19.3346 2.66667V21.3333C19.3346 21.3333 19.3346 24 16.668 24H7.33464Z"
        fill="#31373D"
      />
      <path d="M6 3.33331H18V20.6666H6V3.33331Z" fill="#55ACEE" />
    </svg>
  );
}

export function SendIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ? size : "24"}
      height={size ? size : "24"}
      viewBox="0 0 24 24"
      fill={color ? color : "none"}
    >
      <path
        d="M7.69016 11.897L9.10016 12.367C10.0322 12.677 10.4972 12.833 10.8312 13.167C11.1652 13.501 11.3212 13.967 11.6312 14.897L12.1012 16.307C12.8852 18.661 13.2772 19.837 13.9982 19.837C14.7182 19.837 15.1112 18.661 15.8952 16.307L18.7332 7.79502C19.2852 6.13902 19.5612 5.31102 19.1242 4.87402C18.6872 4.43702 17.8592 4.71302 16.2042 5.26402L7.68916 8.10402C5.33816 8.88702 4.16016 9.27902 4.16016 10C4.16016 10.72 5.33716 11.113 7.69016 11.897Z"
        fill="black"
        fill-opacity="0.25"
      />
      <path
        d="M7.69016 11.897L9.10016 12.367C10.0322 12.677 10.4972 12.833 10.8312 13.167C11.1652 13.501 11.3212 13.967 11.6312 14.897L12.1012 16.307C12.8852 18.661 13.2772 19.837 13.9982 19.837C14.7182 19.837 15.1112 18.661 15.8952 16.307L18.7332 7.79502C19.2852 6.13902 19.5612 5.31102 19.1242 4.87402C18.6872 4.43702 17.8592 4.71302 16.2042 5.26402L7.68916 8.10402C5.33816 8.88702 4.16016 9.27902 4.16016 10C4.16016 10.72 5.33716 11.113 7.69016 11.897Z"
        fill="black"
        fill-opacity="0.25"
      />
      <path
        d="M9.52687 13.842L7.46487 13.155C7.32058 13.1069 7.16723 13.0924 7.01647 13.1125C6.86571 13.1326 6.72152 13.1868 6.59487 13.271L5.50487 13.997C5.37584 14.083 5.27457 14.2046 5.21338 14.3471C5.15219 14.4895 5.13371 14.6467 5.1602 14.7994C5.18668 14.9522 5.25699 15.094 5.36256 15.2075C5.46814 15.3211 5.60443 15.4015 5.75487 15.439L7.70987 15.927C7.79785 15.949 7.8782 15.9945 7.94232 16.0586C8.00643 16.1227 8.05191 16.203 8.07387 16.291L8.56187 18.246C8.59939 18.3965 8.67981 18.5328 8.79335 18.6383C8.9069 18.7439 9.04868 18.8142 9.20144 18.8407C9.35421 18.8672 9.51138 18.8487 9.65384 18.7875C9.7963 18.7263 9.91791 18.6251 10.0039 18.496L10.7299 17.406C10.8141 17.2794 10.8683 17.1352 10.8884 16.9844C10.9085 16.8337 10.894 16.6803 10.8459 16.536L10.1589 14.474C10.1098 14.3269 10.0271 14.1932 9.91741 14.0835C9.80772 13.9738 9.67402 13.8911 9.52687 13.842Z"
        fill="black"
      />
    </svg>
  );
}

export function InstagramIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ? size : "21"}
      height={size ? size : "21"}
      viewBox="0 0 21 21"
      fill={color ? color : "none"}
    >
      <g clip-path="url(#clip0_64_2345)">
        <path
          d="M15.5312 0.512451H4.90625C2.31742 0.512451 0.21875 2.61112 0.21875 5.19995V15.825C0.21875 18.4138 2.31742 20.5125 4.90625 20.5125H15.5312C18.1201 20.5125 20.2188 18.4138 20.2188 15.825V5.19995C20.2188 2.61112 18.1201 0.512451 15.5312 0.512451Z"
          fill="url(#paint0_radial_64_2345)"
        />
        <path
          d="M15.5312 0.512451H4.90625C2.31742 0.512451 0.21875 2.61112 0.21875 5.19995V15.825C0.21875 18.4138 2.31742 20.5125 4.90625 20.5125H15.5312C18.1201 20.5125 20.2188 18.4138 20.2188 15.825V5.19995C20.2188 2.61112 18.1201 0.512451 15.5312 0.512451Z"
          fill="url(#paint1_radial_64_2345)"
        />
        <path
          d="M10.2195 2.69995C8.09773 2.69995 7.83141 2.70925 6.99813 2.74714C6.16641 2.78526 5.59867 2.9169 5.10195 3.11011C4.58805 3.30964 4.15219 3.57659 3.71797 4.01097C3.28336 4.44526 3.01641 4.88112 2.81625 5.39479C2.6225 5.89167 2.4907 6.45964 2.45328 7.29097C2.41602 8.12433 2.40625 8.39073 2.40625 10.5125C2.40625 12.6343 2.41563 12.8998 2.45344 13.7331C2.49172 14.5648 2.62336 15.1325 2.81641 15.6292C3.01609 16.1432 3.28305 16.579 3.71742 17.0132C4.15156 17.4478 4.58742 17.7154 5.10094 17.915C5.59805 18.1082 6.16586 18.2398 6.99742 18.2779C7.83078 18.3158 8.09688 18.3251 10.2185 18.3251C12.3405 18.3251 12.6059 18.3158 13.4392 18.2779C14.2709 18.2398 14.8393 18.1082 15.3364 17.915C15.8501 17.7154 16.2853 17.4478 16.7194 17.0132C17.154 16.579 17.4209 16.1432 17.6211 15.6295C17.8131 15.1325 17.945 14.5646 17.9841 13.7332C18.0215 12.9 18.0312 12.6343 18.0312 10.5125C18.0312 8.39073 18.0215 8.12448 17.9841 7.29112C17.945 6.4594 17.8131 5.89175 17.6211 5.39503C17.4209 4.88112 17.154 4.44526 16.7194 4.01097C16.2848 3.57644 15.8502 3.30948 15.3359 3.11019C14.8379 2.9169 14.2698 2.78519 13.4381 2.74714C12.6048 2.70925 12.3395 2.69995 10.217 2.69995H10.2195ZM9.51859 4.10784C9.72664 4.10753 9.95875 4.10784 10.2195 4.10784C12.3055 4.10784 12.5527 4.11534 13.3764 4.15276C14.1381 4.18761 14.5516 4.31487 14.827 4.42183C15.1916 4.56339 15.4515 4.73269 15.7248 5.0062C15.9982 5.27964 16.1674 5.54003 16.3094 5.90464C16.4163 6.17964 16.5438 6.59308 16.5784 7.35479C16.6159 8.17839 16.624 8.42573 16.624 10.5107C16.624 12.5957 16.6159 12.8432 16.5784 13.6667C16.5436 14.4284 16.4163 14.8418 16.3094 15.1169C16.1678 15.4815 15.9982 15.7411 15.7248 16.0144C15.4513 16.2878 15.1917 16.4571 14.827 16.5987C14.5519 16.7061 14.1381 16.8331 13.3764 16.8679C12.5528 16.9053 12.3055 16.9135 10.2195 16.9135C8.13336 16.9135 7.88609 16.9053 7.06258 16.8679C6.30086 16.8328 5.88742 16.7055 5.6118 16.5985C5.24727 16.4569 4.9868 16.2877 4.71336 16.0142C4.43992 15.7408 4.2707 15.481 4.12875 15.1163C4.0218 14.8412 3.89437 14.4278 3.85969 13.666C3.82227 12.8425 3.81477 12.5951 3.81477 10.5088C3.81477 8.42253 3.82227 8.17644 3.85969 7.35284C3.89453 6.59112 4.0218 6.17769 4.12875 5.90229C4.27039 5.53769 4.43992 5.2773 4.71344 5.00386C4.98688 4.73042 5.24727 4.56112 5.61187 4.41925C5.88727 4.31183 6.30086 4.18487 7.06258 4.14987C7.78328 4.11729 8.06258 4.10753 9.51859 4.10589V4.10784ZM14.3898 5.40503C13.8722 5.40503 13.4523 5.82456 13.4523 6.34222C13.4523 6.8598 13.8722 7.27972 14.3898 7.27972C14.9073 7.27972 15.3273 6.8598 15.3273 6.34222C15.3273 5.82464 14.9073 5.40472 14.3898 5.40472V5.40503ZM10.2195 6.50042C8.00383 6.50042 6.20742 8.29683 6.20742 10.5125C6.20742 12.7282 8.00383 14.5238 10.2195 14.5238C12.4352 14.5238 14.2309 12.7282 14.2309 10.5125C14.2309 8.2969 12.435 6.50042 10.2193 6.50042H10.2195ZM10.2195 7.90831C11.6577 7.90831 12.8237 9.07417 12.8237 10.5125C12.8237 11.9507 11.6577 13.1167 10.2195 13.1167C8.78117 13.1167 7.61531 11.9507 7.61531 10.5125C7.61531 9.07417 8.78117 7.90831 10.2195 7.90831Z"
          fill="white"
        />
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_64_2345"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(5.53125 22.0528) rotate(-90) scale(19.8215 18.4355)"
        >
          <stop stop-color="#FFDD55" />
          <stop offset="0.1" stop-color="#FFDD55" />
          <stop offset="0.5" stop-color="#FF543E" />
          <stop offset="1" stop-color="#C837AB" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_64_2345"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-3.13133 1.95315) rotate(78.681) scale(8.86031 36.5225)"
        >
          <stop stop-color="#3771C8" />
          <stop offset="0.128" stop-color="#3771C8" />
          <stop offset="1" stop-color="#6600FF" stop-opacity="0" />
        </radialGradient>
        <clipPath id="clip0_64_2345">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.21875 0.512451)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function LockIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ? size : "16"}
      height={size ? size : "22"}
      viewBox="0 0 16 22"
      fill={color ? color : "none"}
    >
      <path
        d="M8 16.1973C8.53043 16.1973 9.03914 15.9866 9.41421 15.6115C9.78929 15.2364 10 14.7277 10 14.1973C10 13.0873 9.1 12.1973 8 12.1973C7.46957 12.1973 6.96086 12.408 6.58579 12.7831C6.21071 13.1581 6 13.6668 6 14.1973C6 14.7277 6.21071 15.2364 6.58579 15.6115C6.96086 15.9866 7.46957 16.1973 8 16.1973ZM14 7.19727C14.5304 7.19727 15.0391 7.40798 15.4142 7.78305C15.7893 8.15813 16 8.66683 16 9.19727V19.1973C16 19.7277 15.7893 20.2364 15.4142 20.6115C15.0391 20.9866 14.5304 21.1973 14 21.1973H2C1.46957 21.1973 0.960859 20.9866 0.585786 20.6115C0.210714 20.2364 0 19.7277 0 19.1973V9.19727C0 8.08727 0.9 7.19727 2 7.19727H3V5.19727C3 3.87118 3.52678 2.59941 4.46447 1.66173C5.40215 0.72405 6.67392 0.197266 8 0.197266C8.65661 0.197266 9.30679 0.326594 9.91342 0.577868C10.52 0.829141 11.0712 1.19744 11.5355 1.66173C11.9998 2.12602 12.3681 2.67722 12.6194 3.28385C12.8707 3.89048 13 4.54066 13 5.19727V7.19727H14ZM8 2.19727C7.20435 2.19727 6.44129 2.51334 5.87868 3.07595C5.31607 3.63855 5 4.40162 5 5.19727V7.19727H11V5.19727C11 4.40162 10.6839 3.63855 10.1213 3.07595C9.55871 2.51334 8.79565 2.19727 8 2.19727Z"
        fill="#252A4D"
      />
    </svg>
  );
}

export function CarIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ? size : "24"}
      height={size ? size : "24"}
      viewBox="0 0 24 24"
      fill={"none"}
    >
      <path
        d="M5 10L6.75282 11.4023C7.1707 11.7366 7.7777 11.6826 8.13009 11.2799L11 8"
        stroke={color ? color : "#28303F"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 19V7M14 19H16M14 19H9M14 7C14 4.79086 12.2091 3 10 3H6C3.79086 3 2 4.79086 2 7V15C2 16.8652 3.27667 18.4323 5.00384 18.875M14 7H17.2091C17.7172 7 18.2063 7.1934 18.577 7.54093L21.3679 10.1574C21.7712 10.5355 22 11.0636 22 11.6165V17C22 18.1046 21.1046 19 20 19M20 19C20 20.1046 19.1046 21 18 21C16.8954 21 16 20.1046 16 19M20 19C20 17.8954 19.1046 17 18 17C16.8954 17 16 17.8954 16 19M9 19C9 20.1046 8.10457 21 7 21C5.89543 21 5 20.1046 5 19C5 18.958 5.00129 18.9163 5.00384 18.875M9 19C9 17.8954 8.10457 17 7 17C5.93742 17 5.06838 17.8286 5.00384 18.875"
        stroke={color ? color : "#28303F"}
        strokeWidth="1.5"
      />
    </svg>
  );
}

export function RetailChain({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ? size : "24"}
      height={size ? size : "24"}
      viewBox="0 0 24 24"
      fill={"none"}
    >
      <path
        d="M7 18C7 16.8954 7.89543 16 9 16C10.1046 16 11 16.8954 11 18V22H7V18Z"
        stroke={color ? color : "#28303F"}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M22 8.25V6C22 3.79086 20.2091 2 18 2H6C3.79086 2 2 3.79086 2 6V8.25C2 10.3211 3.49238 12 5.33333 12C7.17428 12 8.66667 10.3211 8.66667 8.25C8.66667 10.3211 10.1591 12 12 12C13.841 12 15.3333 10.3211 15.3333 8.25C15.3333 10.3211 16.8257 12 18.6667 12C20.5076 12 22 10.3211 22 8.25Z"
        stroke={color ? color : "#28303F"}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M14 15C14 14.4477 14.4477 14 15 14H17C17.5523 14 18 14.4477 18 15V16C18 16.5523 17.5523 17 17 17H15C14.4477 17 14 16.5523 14 16V15Z"
        stroke={color ? color : "#28303F"}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M21 11V18C21 20.2091 19.2091 22 17 22H7C4.79086 22 3 20.2091 3 18V11"
        stroke={color ? color : "#28303F"}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function DashboardIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ? size : "23"}
      height={size ? size : "23"}
      viewBox="0 0 23 23"
      fill="none"
    >
      <path
        d="M4 18.6329C4 20.4857 8.19307 21.329 12.0885 21.329C15.9839 21.329 20.177 20.4857 20.177 18.6329C20.177 17.1618 17.6307 16.4975 15.7962 16.2106L17.0494 14.9661C18.0298 13.9857 18.6975 12.7367 18.9681 11.3768C19.2386 10.017 19.0998 8.60751 18.5693 7.32656C18.0387 6.04561 17.1402 4.95076 15.9874 4.18047C14.8346 3.41017 13.4793 2.99902 12.0928 2.99902C10.7063 2.99902 9.35098 3.41017 8.19818 4.18047C7.04537 4.95076 6.14688 6.04561 5.61633 7.32656C5.08577 8.60751 4.94699 10.017 5.21752 11.3768C5.48805 12.7367 6.15575 13.9857 7.13617 14.9661L8.38504 16.2149C6.54625 16.4975 4 17.1618 4 18.6329ZM13.1669 7.30899C13.1669 7.20884 13.1948 7.11068 13.2475 7.0255C13.3001 6.94031 13.3755 6.87147 13.465 6.82668C13.5546 6.7819 13.6549 6.76294 13.7546 6.77193C13.8543 6.78093 13.9496 6.81752 14.0297 6.8776C14.6975 7.37859 15.2519 8.01488 15.6569 8.74486C16.0618 9.47485 16.3081 10.2821 16.3797 11.1138C16.4034 11.3693 16.3345 11.6248 16.1857 11.8338C16.0368 12.0429 15.8179 12.1915 15.5687 12.2527L14.2454 12.5838V13.7798C14.2454 13.9228 14.1886 14.0599 14.0875 14.1611C13.9864 14.2622 13.8492 14.319 13.7062 14.319C13.5632 14.319 13.426 14.2622 13.3249 14.1611C13.2238 14.0599 13.1669 13.9228 13.1669 13.7798V7.30899ZM8.31386 8.38745V7.30899C8.31386 7.16597 8.37067 7.02882 8.4718 6.92769C8.57292 6.82657 8.71008 6.76975 8.85309 6.76975C8.9961 6.76975 9.13326 6.82657 9.23439 6.92769C9.33551 7.02882 9.39232 7.16597 9.39232 7.30899V8.38745C9.39447 8.57343 9.4454 8.75558 9.54003 8.91569C9.63466 9.0758 9.76967 9.20827 9.93155 9.29983V7.30899C9.93155 7.16597 9.98837 7.02882 10.0895 6.92769C10.1906 6.82657 10.3278 6.76975 10.4708 6.76975C10.6138 6.76975 10.751 6.82657 10.8521 6.92769C10.9532 7.02882 11.01 7.16597 11.01 7.30899V9.29983C11.1719 9.20827 11.3069 9.0758 11.4015 8.91569C11.4962 8.75558 11.5471 8.57343 11.5493 8.38745V7.30899C11.5493 7.16597 11.6061 7.02882 11.7072 6.92769C11.8083 6.82657 11.9455 6.76975 12.0885 6.76975C12.2315 6.76975 12.3687 6.82657 12.4698 6.92769C12.5709 7.02882 12.6277 7.16597 12.6277 7.30899V8.38745C12.6259 8.86425 12.4662 9.32701 12.1735 9.70341C11.8808 10.0798 11.4717 10.3486 11.01 10.4678V13.7798C11.01 13.9228 10.9532 14.0599 10.8521 14.1611C10.751 14.2622 10.6138 14.319 10.4708 14.319C10.3278 14.319 10.1906 14.2622 10.0895 14.1611C9.98837 14.0599 9.93155 13.9228 9.93155 13.7798V10.4678C9.46989 10.3486 9.06074 10.0798 8.76805 9.70341C8.47537 9.32701 8.31564 8.86425 8.31386 8.38745ZM9.34271 17.1726L10.9442 18.7752C11.0945 18.9255 11.2728 19.0448 11.4692 19.1262C11.6655 19.2075 11.876 19.2494 12.0885 19.2494C12.301 19.2494 12.5115 19.2075 12.7078 19.1262C12.9041 19.0448 13.0825 18.9255 13.2327 18.7752L14.8343 17.1726C17.7979 17.5156 19.0985 18.2964 19.0985 18.6329C19.0985 19.116 16.714 20.2506 12.0885 20.2506C7.46295 20.2506 5.07846 19.116 5.07846 18.6329C5.07846 18.2964 6.37909 17.5156 9.34271 17.1726Z"
        fill={color ? color : "white"}
      />
    </svg>
  );
}

export function PendingOrdersIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ? size : "23"}
      height={size ? size : "23"}
      viewBox="0 0 23 23"
      fill="none"
    >
      <path
        d="M15.0754 15.0466H8.45703"
        stroke={color ? color : "#53545C"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0754 11.209H8.45703"
        stroke={color ? color : "#53545C"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9824 7.38013H8.45703"
        stroke={color ? color : "#53545C"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2523 2.6958C15.2523 2.6958 8.21501 2.69947 8.20401 2.69947C5.67401 2.71505 4.10742 4.37972 4.10742 6.91888V15.3486C4.10742 17.9006 5.68592 19.5716 8.23792 19.5716C8.23792 19.5716 15.2743 19.5689 15.2862 19.5689C17.8162 19.5533 19.3837 17.8877 19.3837 15.3486V6.91888C19.3837 4.36688 17.8043 2.6958 15.2523 2.6958Z"
        stroke={color ? color : "#53545C"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function AnalyticsIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
    >
      <path
        d="M11 1C12.1046 1 13 1.89543 13 3L13 17C13 18.1046 12.1046 19 11 19C9.89543 19 9 18.1046 9 17L9 3C9 1.89543 9.89543 1 11 1Z"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M3 10C4.10457 10 5 10.8954 5 12L5 17C5 18.1046 4.10457 19 3 19C1.89543 19 1 18.1046 1 17L1 12C1 10.8954 1.89543 10 3 10Z"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M19 6C20.1046 6 21 6.89543 21 8V17C21 18.1046 20.1046 19 19 19C17.8954 19 17 18.1046 17 17V8C17 6.89543 17.8954 6 19 6Z"
        stroke="white"
        strokeWidth="1.5"
      />
    </svg>
  );
}

export function OrderHistoryIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ? size : "21"}
      height={size ? size : "21"}
      viewBox="0 0 21 21"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3938 0.324618C10.4858 0.322078 10.578 0.320801 10.6706 0.320801C16.1129 0.320801 20.5247 4.73266 20.5247 10.175C20.5247 10.2675 20.5235 10.3598 20.5209 10.4517C20.5104 10.8313 20.1943 11.1305 19.8147 11.12C19.4352 11.1095 19.136 10.7933 19.1464 10.4138C19.1486 10.3345 19.1497 10.2549 19.1497 10.175C19.1497 5.49205 15.3535 1.6958 10.6706 1.6958C10.5907 1.6958 10.5111 1.6969 10.4318 1.69909C10.0522 1.70957 9.73603 1.41038 9.72555 1.03083C9.71507 0.651281 10.0143 0.335098 10.3938 0.324618ZM8.04275 1.36345C8.17824 1.71815 8.00053 2.11552 7.64583 2.25101C7.4974 2.3077 7.35096 2.36845 7.20665 2.43313C6.86016 2.58841 6.45339 2.43341 6.29811 2.08692C6.14282 1.74043 6.29782 1.33366 6.64431 1.17838C6.81216 1.10315 6.98251 1.03248 7.1552 0.96652C7.5099 0.831036 7.90727 1.00875 8.04275 1.36345ZM4.8726 3.04149C5.1335 3.31735 5.12136 3.75248 4.8455 4.01338C4.73022 4.1224 4.61801 4.23462 4.50899 4.34989C4.24809 4.62576 3.81296 4.63789 3.53709 4.37699C3.26123 4.1161 3.24909 3.68097 3.50999 3.4051C3.63657 3.27126 3.76686 3.14097 3.90071 3.01438C4.17657 2.75349 4.6117 2.76562 4.8726 3.04149ZM2.58253 5.8025C2.92902 5.95779 3.08402 6.36456 2.92873 6.71105C2.86406 6.85535 2.80331 7.00179 2.74661 7.15022C2.61113 7.50492 2.21376 7.68263 1.85905 7.54715C1.50435 7.41167 1.32664 7.01429 1.46213 6.65959C1.52809 6.4869 1.59876 6.31656 1.67398 6.14871C1.82927 5.80222 2.23604 5.64721 2.58253 5.8025ZM1.52644 9.22994C1.90599 9.24042 2.20518 9.55661 2.1947 9.93616C2.19251 10.0155 2.19141 10.0951 2.19141 10.175C2.19141 10.2549 2.19251 10.3345 2.1947 10.4138C2.20518 10.7933 1.90599 11.1095 1.52644 11.12C1.14689 11.1305 0.830703 10.8313 0.820223 10.4517C0.817684 10.3598 0.816406 10.2675 0.816406 10.175C0.816406 10.0824 0.817684 9.99017 0.820223 9.89821C0.830703 9.51865 1.14689 9.21946 1.52644 9.22994ZM1.85905 12.8028C2.21376 12.6673 2.61113 12.845 2.74661 13.1997C2.80331 13.3481 2.86406 13.4946 2.92873 13.6389C3.08402 13.9854 2.92902 14.3921 2.58253 14.5474C2.23604 14.7027 1.82927 14.5477 1.67398 14.2012C1.59876 14.0334 1.52809 13.863 1.46213 13.6903C1.32664 13.3356 1.50435 12.9383 1.85905 12.8028ZM19.4821 12.8028C19.8368 12.9383 20.0145 13.3356 19.879 13.6903C19.8131 13.863 19.7424 14.0334 19.6672 14.2012C19.5119 14.5477 19.1051 14.7027 18.7586 14.5474C18.4121 14.3921 18.2571 13.9854 18.4124 13.6389C18.4771 13.4946 18.5378 13.3481 18.5945 13.1997C18.73 12.845 19.1274 12.6673 19.4821 12.8028ZM3.53709 15.9729C3.81296 15.712 4.24809 15.7242 4.50899 16C4.61801 16.1153 4.73022 16.2275 4.8455 16.3366C5.12136 16.5975 5.1335 17.0326 4.8726 17.3084C4.6117 17.5843 4.17657 17.5964 3.90071 17.3356C3.76686 17.209 3.63657 17.0787 3.50999 16.9448C3.24909 16.669 3.26123 16.2338 3.53709 15.9729ZM17.8041 15.9729C18.0799 16.2338 18.0921 16.669 17.8312 16.9448C17.7046 17.0787 17.5743 17.209 17.4404 17.3355C17.1646 17.5964 16.7294 17.5843 16.4685 17.3084C16.2076 17.0326 16.2198 16.5975 16.4956 16.3366C16.6109 16.2275 16.7231 16.1153 16.8322 16C17.0931 15.7242 17.5282 15.712 17.8041 15.9729ZM15.043 18.263C15.1983 18.6095 15.0433 19.0163 14.6968 19.1716C14.529 19.2468 14.3586 19.3175 14.186 19.3834C13.8312 19.5189 13.4339 19.3412 13.2984 18.9865C13.1629 18.6318 13.3406 18.2344 13.6953 18.0989C13.8437 18.0422 13.9902 17.9815 14.1345 17.9168C14.481 17.7615 14.8878 17.9165 15.043 18.263ZM6.29811 18.263C6.45339 17.9165 6.86016 17.7615 7.20665 17.9168C7.35096 17.9815 7.4974 18.0422 7.64583 18.0989C8.00053 18.2344 8.17824 18.6318 8.04275 18.9865C7.90727 19.3412 7.5099 19.5189 7.1552 19.3834C6.98251 19.3175 6.81216 19.2468 6.64431 19.1716C6.29782 19.0163 6.14282 18.6095 6.29811 18.263ZM9.72555 19.3191C9.73603 18.9396 10.0522 18.6404 10.4318 18.6508C10.5111 18.653 10.5907 18.6541 10.6706 18.6541C10.7505 18.6541 10.8301 18.653 10.9094 18.6508C11.2889 18.6404 11.6051 18.9396 11.6156 19.3191C11.6261 19.6987 11.3269 20.0148 10.9473 20.0253C10.8554 20.0279 10.7631 20.0291 10.6706 20.0291C10.578 20.0291 10.4858 20.0279 10.3938 20.0253C10.0143 20.0148 9.71507 19.6987 9.72555 19.3191ZM10.6706 3.98747C10.2909 3.98747 9.98307 4.29527 9.98307 4.67497V8.4749C9.3112 8.74687 8.83724 9.40557 8.83724 10.175C8.83724 11.1875 9.65805 12.0083 10.6706 12.0083C11.44 12.0083 12.0987 11.5343 12.3706 10.8625H14.3372C14.7169 10.8625 15.0247 10.5547 15.0247 10.175C15.0247 9.79527 14.7169 9.48747 14.3372 9.48747H12.3706C12.1846 9.0279 11.8176 8.66093 11.3581 8.4749V4.67497C11.3581 4.29527 11.0503 3.98747 10.6706 3.98747Z"
        fill={color ? color : "white"}
      />
    </svg>
  );
}

export function HelpIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ? size : "20"}
      height={size ? size : "21"}
      viewBox="0 0 20 21"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.0039 10.0725C20.0039 15.5954 15.5268 20.0725 10.0039 20.0725C4.48106 20.0725 0.00390625 15.5954 0.00390625 10.0725C0.00390625 4.54966 4.48106 0.0725098 10.0039 0.0725098C15.5268 0.0725098 20.0039 4.54966 20.0039 10.0725ZM10.0039 5.82251C9.31355 5.82251 8.75391 6.38215 8.75391 7.07251C8.75391 7.48672 8.41812 7.82251 8.00391 7.82251C7.58969 7.82251 7.25391 7.48672 7.25391 7.07251C7.25391 5.55373 8.48512 4.32251 10.0039 4.32251C11.5227 4.32251 12.7539 5.55373 12.7539 7.07251C12.7539 7.61885 12.5938 8.13008 12.3177 8.55914C12.1448 8.82788 11.9426 9.08445 11.7562 9.31614L11.6557 9.44076C11.501 9.63221 11.359 9.80795 11.2278 9.98828C10.9042 10.433 10.7539 10.7672 10.7539 11.0725V11.5725C10.7539 11.9867 10.4181 12.3225 10.0039 12.3225C9.58969 12.3225 9.25391 11.9867 9.25391 11.5725V11.0725C9.25391 10.2732 9.64632 9.61228 10.0149 9.10576C10.1706 8.89174 10.3412 8.68065 10.4964 8.4887L10.5875 8.3758C10.7727 8.14564 10.9304 7.94316 11.0563 7.74746C11.1813 7.55319 11.2539 7.32247 11.2539 7.07251C11.2539 6.38215 10.6943 5.82251 10.0039 5.82251ZM10.7539 14.0725C10.7539 13.6583 10.4181 13.3225 10.0039 13.3225C9.58969 13.3225 9.25391 13.6583 9.25391 14.0725V15.0725C9.25391 15.4867 9.58969 15.8225 10.0039 15.8225C10.4181 15.8225 10.7539 15.4867 10.7539 15.0725V14.0725Z"
        fill="#28303F"
      />
    </svg>
  );
}

export function LogoutIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill={color ? color : "white"}
    >
      <path
        d="M16.8359 13.0781L17.9622 11.9519C18.3527 11.5614 18.3527 10.9282 17.9622 10.5377L16.8359 9.41146"
        stroke={color ? color : "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.752 11.2441L12.252 11.2441M4.00195 16.0716V6.90494M15.002 16.0716C15.002 17.0841 14.1811 17.9049 13.1686 17.9049H9.50195M15.002 6.90494C15.002 5.89242 14.1811 5.07161 13.1686 5.07161H9.50195M4.81834 18.4492L6.65167 19.6714C7.87002 20.4837 9.50195 19.6103 9.50195 18.146V4.83056C9.50195 3.36628 7.87002 2.4929 6.65167 3.30513L4.81834 4.52735C4.30831 4.86737 4.00195 5.4398 4.00195 6.05278V16.9238C4.00195 17.5368 4.30831 18.1092 4.81834 18.4492Z"
        stroke={color ? color : "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function LocationIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
    >
      <g clip-path="url(#clip0_447_18812)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.76756 14.1995L7.76966 14.2004C7.9175 14.2648 8 14.2498 8 14.2498C8 14.2498 8.0825 14.2648 8.23093 14.2002L8.23244 14.1995L8.23674 14.1975L8.25036 14.1913C8.26163 14.186 8.27725 14.1787 8.29693 14.1692C8.33628 14.1502 8.39191 14.1227 8.4615 14.0864C8.60058 14.0139 8.79591 13.9062 9.02874 13.7619C9.49342 13.4739 10.113 13.0367 10.7341 12.4381C11.9766 11.2405 13.25 9.36912 13.25 6.74976C13.25 3.85026 10.8995 1.49976 8 1.49976C5.10051 1.49976 2.75 3.85026 2.75 6.74976C2.75 9.36912 4.02337 11.2405 5.26589 12.4381C5.88698 13.0367 6.50658 13.4739 6.97126 13.7619C7.20409 13.9062 7.39942 14.0139 7.5385 14.0864C7.60809 14.1227 7.66372 14.1502 7.70307 14.1692C7.72275 14.1787 7.73837 14.186 7.74964 14.1913L7.76326 14.1975L7.76756 14.1995ZM8 8.43726C8.93198 8.43726 9.6875 7.68174 9.6875 6.74976C9.6875 5.81778 8.93198 5.06226 8 5.06226C7.06802 5.06226 6.3125 5.81778 6.3125 6.74976C6.3125 7.68174 7.06802 8.43726 8 8.43726Z"
          fill={color ? color : "#BDC167"}
        />
      </g>
      <defs>
        <clipPath id="clip0_447_18812">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(0.5 -0.000244141)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function DiscountIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.99889 6.3797C3.99889 5.33887 4.84222 4.49554 5.88306 4.4947H6.74056C7.23806 4.4947 7.71472 4.2972 8.06806 3.9472L8.66722 3.3472C9.40139 2.60887 10.5947 2.60554 11.3331 3.3397L11.3339 3.34054L11.3414 3.3472L11.9414 3.9472C12.2947 4.29804 12.7714 4.4947 13.2689 4.4947H14.1256C15.1664 4.4947 16.0106 5.33804 16.0106 6.3797V7.23554C16.0106 7.73304 16.2072 8.21054 16.5581 8.56387L17.1581 9.16387C17.8964 9.89804 17.9006 11.0914 17.1664 11.8297L17.1656 11.8305L17.1581 11.838L16.5581 12.438C16.2072 12.7905 16.0106 13.2672 16.0106 13.7647V14.6222C16.0106 15.663 15.1672 16.5064 14.1264 16.5064H13.2672C12.7697 16.5064 12.2922 16.7039 11.9397 17.0547L11.3397 17.6539C10.6064 18.3922 9.41389 18.3964 8.67556 17.6639C8.67473 17.663 8.67389 17.6622 8.67306 17.6614L8.66556 17.6539L8.06639 17.0547C7.71389 16.7039 7.23639 16.5072 6.73889 16.5064H5.88306C4.84222 16.5064 3.99889 15.663 3.99889 14.6222V13.763C3.99889 13.2655 3.80139 12.7889 3.45056 12.4364L2.85139 11.8364C2.11306 11.103 2.10889 9.91054 2.84222 9.1722C2.84222 9.17137 2.84306 9.17054 2.84389 9.1697L2.85139 9.1622L3.45056 8.5622C3.80139 8.20887 3.99889 7.7322 3.99889 7.23387V6.3797Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.86328 12.6427L12.1466 8.35938"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.082 12.583H12.0895"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.91602 8.41626H7.92352"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function NotificationIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
    >
      <path
        d="M8.30591 16.5231C8.7225 16.435 11.261 16.435 11.6776 16.5231C12.0337 16.6053 12.4188 16.7975 12.4188 17.2172C12.3981 17.6167 12.1637 17.9709 11.8399 18.1958C11.42 18.5232 10.9272 18.7305 10.4121 18.8052C10.1272 18.8421 9.84722 18.8429 9.57225 18.8052C9.05627 18.7305 8.56348 18.5232 8.1444 18.195C7.81974 17.9709 7.58536 17.6167 7.56465 17.2172C7.56465 16.7975 7.94977 16.6053 8.30591 16.5231ZM10.0409 2.1665C11.7744 2.1665 13.5451 2.98902 14.597 4.35372C15.2794 5.23247 15.5925 6.11038 15.5925 7.47509V7.83011C15.5925 8.87672 15.8691 9.49361 16.4778 10.2045C16.9392 10.7282 17.0866 11.4005 17.0866 12.1299C17.0866 12.8584 16.8472 13.55 16.3677 14.1114C15.7399 14.7846 14.8545 15.2143 13.951 15.289C12.6415 15.4006 11.3313 15.4946 10.0037 15.4946C8.67521 15.4946 7.3658 15.4384 6.05638 15.289C5.15197 15.2143 4.2666 14.7846 3.63964 14.1114C3.16011 13.55 2.91992 12.8584 2.91992 12.1299C2.91992 11.4005 3.06817 10.7282 3.52866 10.2045C4.15645 9.49361 4.41486 8.87672 4.41486 7.83011V7.47509C4.41486 6.07345 4.76436 5.15694 5.48408 4.25972C6.55414 2.95125 8.26938 2.1665 9.9664 2.1665H10.0409Z"
        fill="#2B315A"
      />
    </svg>
  );
}

export function CartIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
    >
      <g clip-path="url(#clip0_447_18830)">
        <path
          d="M5.00326 4.07902H15.0033C16.8442 4.07902 18.3366 5.5714 18.3366 7.41235V11.579C18.3366 13.42 16.8442 14.9124 15.0033 14.9124H8.33659C6.49564 14.9124 5.00326 13.42 5.00326 11.579V4.07902ZM5.00326 4.07902C5.00326 3.15855 4.25706 2.41235 3.33659 2.41235H1.66992"
          stroke="#28303F"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.16992 17.8289C9.16992 18.5192 8.61028 19.0789 7.91992 19.0789C7.22957 19.0789 6.66992 18.5192 6.66992 17.8289C6.66992 17.1385 7.22957 16.5789 7.91992 16.5789C8.61028 16.5789 9.16992 17.1385 9.16992 17.8289Z"
          stroke="#28303F"
          strokeWidth="1.5"
        />
        <path
          d="M16.6699 17.8289C16.6699 18.5192 16.1103 19.0789 15.4199 19.0789C14.7296 19.0789 14.1699 18.5192 14.1699 17.8289C14.1699 17.1385 14.7296 16.5789 15.4199 16.5789C16.1103 16.5789 16.6699 17.1385 16.6699 17.8289Z"
          stroke="#28303F"
          strokeWidth="1.5"
        />
        <path
          d="M9.16992 7.82886H14.1699"
          stroke="#28303F"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.16992 11.1624H14.1699"
          stroke="#28303F"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_447_18830">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.00390625 0.745605)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function PizzaShapeIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
    >
      <g clip-path="url(#clip0_2990_19346)">
        <path
          d="M0.630859 10.0187V11.9089H15.6118C16.0329 11.9089 16.3542 9.98534 16.3542 9.98534L0.630859 10.0187Z"
          fill="#F2C05A"
        />
        <path
          d="M0.629288 12.3706C0.369658 12.3706 0.166016 12.1674 0.166016 11.9082V10.0178C0.166016 9.76292 0.373834 9.55558 0.629288 9.55558L16.3639 9.52226C16.4946 9.52226 16.6299 9.58418 16.7085 9.67999C16.7989 9.7881 16.8336 9.91951 16.8072 10.0509C16.4233 12.3706 15.8408 12.3706 15.6216 12.3706H0.629288ZM15.4808 11.457L15.5119 11.3947C15.5821 11.2546 15.6632 11.006 15.7748 10.5885L15.8127 10.4466L1.10376 10.4804V11.457H1.21649H15.4808Z"
          fill="#4C2F1B"
        />
        <path
          d="M12.3216 0.666058C12.0003 0.50019 11.6013 0.544497 11.3354 0.787808L0.642578 10.0186H2.63725V15.3361C2.63725 15.9662 3.14683 16.4746 3.77845 16.4746C4.41006 16.4746 4.91964 15.9662 4.91964 15.3361V10.0186H6.10525V12.5281C6.10525 13.1692 6.63704 13.6999 7.27985 13.6999C7.92247 13.6999 8.45445 13.1694 8.45445 12.5281V10.0186H10.1498C10.3161 10.6488 10.8813 11.1131 11.5571 11.1131C12.2331 11.1131 12.8091 10.6488 12.9644 10.0186L16.3772 10.0077C17.4517 3.89423 13.7731 1.3958 12.3216 0.666058Z"
          fill="#FFDE8A"
        />
        <path
          d="M8.79424 4.6899C9.44787 4.6899 9.96884 4.17033 9.96884 3.51803C9.96884 3.06474 9.71395 2.68888 9.34823 2.49007L7.69727 3.91604C7.86352 4.36933 8.28447 4.6899 8.79424 4.6899Z"
          fill="#FF5C5C"
        />
        <path
          d="M8.79651 4.92208C8.20911 4.92208 7.67733 4.54623 7.47786 3.99353C7.44465 3.9051 7.46666 3.8057 7.54429 3.73942L9.19525 2.31327C9.26168 2.24699 9.37252 2.23582 9.44995 2.28013C9.91531 2.52344 10.1924 2.9987 10.1924 3.50729C10.2038 4.29194 9.57217 4.92208 8.79651 4.92208ZM7.97643 3.98255C8.14269 4.28115 8.45299 4.46898 8.79651 4.46898C9.31729 4.46898 9.73843 4.04901 9.73843 3.52925C9.73843 3.23084 9.59438 2.95439 9.36151 2.77754L7.97643 3.98255Z"
          fill="#4C2F1B"
        />
        <path
          d="M12.6856 5.69566C12.5525 6.25953 12.9183 6.83439 13.4833 6.95595C13.8822 7.04437 14.2699 6.90066 14.5138 6.61323L13.5831 4.87768C13.1509 4.93297 12.7852 5.24236 12.6856 5.69566Z"
          fill="#FF5C5C"
        />
        <path
          d="M13.7166 7.2107C13.628 7.2107 13.5283 7.19971 13.4397 7.17756C12.7527 7.02286 12.3095 6.33743 12.4646 5.64101C12.5864 5.12144 13.0185 4.72344 13.5615 4.65717C13.6502 4.64619 13.75 4.6903 13.7942 4.77873L14.7249 6.5033C14.7693 6.59172 14.7581 6.69113 14.6917 6.75759C14.4368 7.04483 14.0823 7.2107 13.7166 7.2107ZM12.9077 5.74042C12.8633 5.96158 12.8967 6.18254 13.0184 6.35939C13.1404 6.54722 13.3177 6.67996 13.5391 6.72426C13.783 6.77955 14.0377 6.71328 14.2372 6.5584L13.4727 5.13243C13.1848 5.23183 12.9741 5.4528 12.9077 5.74042Z"
          fill="#4C2F1B"
        />
        <path
          d="M3.76689 16.9251C2.8821 16.9251 2.16205 16.2069 2.16205 15.324V10.469H0.631027C0.433647 10.469 0.266823 10.3518 0.206091 10.1702C0.133213 9.98746 0.186733 9.78599 0.337045 9.66235L11.032 0.429809C11.2798 0.218876 11.5941 0.102239 11.9166 0.102239C12.129 0.102239 12.3337 0.150712 12.5254 0.246521C13.824 0.899578 17.972 3.53718 16.8196 10.0535C16.7845 10.2722 16.5894 10.4358 16.3654 10.4358L13.2715 10.4472L13.2402 10.5078C12.9101 11.1453 12.2607 11.5414 11.5454 11.5414C10.8302 11.5414 10.1808 11.1455 9.85055 10.5078L9.81886 10.4468H8.90617V12.494C8.90617 13.3891 8.17643 14.1171 7.2793 14.1171C6.38217 14.1171 5.65263 13.3891 5.65263 12.4942V10.447H5.38256V15.302C5.37231 16.1965 4.64751 16.9251 3.76689 16.9251ZM11.9052 1.02758C11.8008 1.02758 11.7042 1.06431 11.6256 1.13399L1.86844 9.55556H2.62551C2.754 9.55556 2.86597 9.60119 2.94056 9.68413C3.03185 9.77539 3.07777 9.88938 3.07777 10.0179V15.3354C3.07777 15.7144 3.38694 16.0229 3.7667 16.0229C4.15311 16.0229 4.45564 15.7209 4.45564 15.3354V10.0178C4.45564 9.76289 4.66345 9.55556 4.91891 9.55556H6.10451C6.23281 9.55556 6.34479 9.60119 6.41956 9.68413C6.51085 9.77539 6.55678 9.88938 6.55678 10.0179V12.5274C6.55678 12.9185 6.87581 13.2368 7.26791 13.2368C7.66002 13.2368 7.97905 12.9185 7.97905 12.5274V10.0068C7.97905 9.75172 8.18687 9.54439 8.44232 9.54439H10.1377C10.3495 9.54439 10.5283 9.68394 10.5826 9.89146C10.6959 10.3315 11.0918 10.639 11.545 10.639C11.9982 10.639 12.3941 10.3315 12.5074 9.89127C12.5617 9.68413 12.7405 9.54458 12.9521 9.54458L15.9756 9.53322L15.9891 9.43665C16.7438 4.04595 13.5252 1.79235 12.1064 1.07359C12.0377 1.04234 11.9714 1.02758 11.9052 1.02758Z"
          fill="#4C2F1B"
        />
        <path
          d="M16.3643 9.98547C17.4724 3.76165 13.6163 1.29635 12.2312 0.622091C11.9542 0.489359 11.6216 0.533666 11.389 0.732669L10.5469 1.46241C12.3863 2.83309 15.4778 5.36485 14.5358 9.99683L16.3643 9.98547Z"
          fill="#FFB07B"
        />
        <path
          d="M14.5389 10.447C14.4043 10.447 14.2709 10.3835 14.1824 10.2773C14.0942 10.1719 14.0576 10.0295 14.0843 9.89597C14.8955 5.89508 12.6076 3.57047 10.2627 1.82431C10.1519 1.74763 10.0847 1.61774 10.075 1.46531C10.0665 1.32785 10.1244 1.19663 10.2341 1.10555L11.0779 0.374296C11.3032 0.180216 11.588 0.0732353 11.8799 0.0732353C12.0655 0.0732353 12.2506 0.117732 12.4155 0.201802C13.7418 0.847095 17.9714 3.46235 16.799 10.0645C16.7639 10.2834 16.5688 10.447 16.3451 10.447H14.5389V10.447ZM11.8864 0.998572C11.8099 0.998572 11.7347 1.02622 11.6742 1.07658L11.2715 1.4335L11.3778 1.51662C12.4406 2.34937 15.6749 4.88359 15.0917 9.39534L15.0754 9.5222H15.9668L15.9803 9.42526C16.7491 3.93174 13.4647 1.72301 12.017 1.0283C11.9784 1.00918 11.9329 0.998572 11.8864 0.998572Z"
          fill="#4C2F1B"
        />
        <path
          d="M14.5371 9.98534C14.5371 9.98534 14.4373 11.2013 13.9941 11.9089H15.6229C15.6229 11.9089 16.1991 11.5993 16.3654 9.98534H14.5371Z"
          fill="#E2803D"
        />
        <path
          d="M13.9923 12.3716C13.8217 12.3716 13.6727 12.2824 13.5934 12.133C13.5104 11.9855 13.5137 11.8092 13.6004 11.6704C13.9194 11.152 14.0508 10.2316 14.0716 9.94981C14.0889 9.71673 14.2878 9.53439 14.5243 9.53439H16.3525C16.4882 9.53439 16.6097 9.58778 16.6864 9.68113C16.783 9.78735 16.823 9.90891 16.8057 10.0371C16.6178 11.8136 15.9543 12.2491 15.8232 12.3184C15.7701 12.353 15.6947 12.3716 15.6211 12.3716H13.9923V12.3716ZM14.9342 10.5385C14.8904 10.7574 14.8357 11.0298 14.7488 11.3124L14.704 11.458H15.4472L15.481 11.4099C15.5573 11.301 15.7015 11.0492 15.8088 10.5858L15.8407 10.448H14.9524L14.9342 10.5385Z"
          fill="#4C2F1B"
        />
        <path
          d="M5.73828 7.67406C5.73828 8.09536 6.08047 8.43675 6.50275 8.43675C6.92503 8.43675 7.26721 8.09536 7.26721 7.67406C7.26721 7.25276 6.92503 6.91137 6.50275 6.91137C6.08047 6.91137 5.73828 7.25276 5.73828 7.67406Z"
          fill="#FF5C5C"
        />
        <path
          d="M6.5032 8.66968C5.96021 8.66968 5.50586 8.22755 5.50586 7.67485C5.50586 7.12215 5.94901 6.67984 6.5032 6.67984C7.05719 6.67984 7.50034 7.12196 7.50034 7.67485C7.50034 8.22737 7.05719 8.66968 6.5032 8.66968ZM6.5032 7.14411C6.20409 7.14411 5.97141 7.38742 5.97141 7.67466C5.97141 7.96209 6.2151 8.20521 6.5032 8.20521C6.79129 8.20521 7.03498 7.9619 7.03498 7.67466C7.03498 7.38723 6.8023 7.14411 6.5032 7.14411Z"
          fill="#4C2F1B"
        />
        <path
          d="M10.2691 8.43767H8.66235C8.57372 8.43767 8.49609 8.36023 8.49609 8.2718V7.90693C8.49609 7.81851 8.57372 7.74106 8.66235 7.74106H10.2691C10.3577 7.74106 10.4354 7.81851 10.4354 7.90693V8.2718C10.4464 8.36023 10.3687 8.43767 10.2691 8.43767Z"
          fill="#3DE25C"
        />
        <path
          d="M10.0946 8.66916H8.85354C8.53223 8.66916 8.27734 8.41487 8.27734 8.0943C8.27734 7.77374 8.53223 7.51945 8.85354 7.51945H10.0946C10.4159 7.51945 10.6708 7.77374 10.6708 8.0943C10.6708 8.41487 10.4159 8.66916 10.0946 8.66916ZM8.85354 7.97255C8.78711 7.97255 8.7317 8.02784 8.7317 8.09411C8.7317 8.16058 8.78711 8.21586 8.85354 8.21586H10.0946C10.161 8.21586 10.2164 8.16058 10.2164 8.09411C10.2164 8.02784 10.161 7.97255 10.0946 7.97255H8.85354Z"
          fill="#4C2F1B"
        />
        <path
          d="M11.3782 6.76777L10.5249 5.83922C10.4917 5.80608 10.4917 5.75079 10.5249 5.71766L10.9126 5.36396C10.9459 5.33082 11.0013 5.33082 11.0347 5.36396L11.888 6.29251C11.9212 6.32565 11.9212 6.38094 11.888 6.41408L11.5002 6.76777C11.4778 6.8011 11.4114 6.8011 11.3782 6.76777Z"
          fill="#3DE25C"
        />
        <path
          d="M11.4549 6.98958H11.4329C11.3221 6.98958 11.2223 6.93429 11.1448 6.85685L10.4136 6.07201C10.3359 5.99457 10.3027 5.88418 10.3027 5.7736C10.3027 5.66321 10.3582 5.56361 10.4358 5.48617L10.6795 5.26501C10.7571 5.18757 10.8679 5.15443 10.9788 5.15443C11.0896 5.15443 11.1892 5.20972 11.2669 5.28717L11.9981 6.07201C12.0757 6.14945 12.1089 6.26003 12.1089 6.37061C12.1089 6.48119 12.0535 6.58059 11.9759 6.65804L11.7322 6.87919C11.6544 6.94527 11.5546 6.98958 11.4549 6.98958ZM10.7901 5.78458L11.4549 6.50315L11.6322 6.33728L10.9674 5.61871L10.7901 5.78458Z"
          fill="#4C2F1B"
        />
      </g>
      <defs>
        <clipPath id="clip0_2990_19346">
          <rect
            width="16.8519"
            height="16.8519"
            fill="white"
            transform="translate(0.166016 0.0735197)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function MoreIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="4"
      viewBox="0 0 17 4"
      fill="none"
    >
      <path
        d="M7.95393 2C7.95393 2.55228 8.35381 3 8.84708 3C9.34036 3 9.74023 2.55228 9.74023 2C9.74023 1.44772 9.34036 1 8.84708 1C8.35381 1 7.95393 1.44772 7.95393 2Z"
        stroke="#CBD5E0"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.70198 2C1.70198 2.55228 2.10186 3 2.59513 3C3.0884 3 3.48828 2.55228 3.48828 2C3.48828 1.44772 3.0884 1 2.59513 1C2.10186 1 1.70198 1.44772 1.70198 2Z"
        stroke="#CBD5E0"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.2059 2C14.2059 2.55228 14.6058 3 15.099 3C15.5923 3 15.9922 2.55228 15.9922 2C15.9922 1.44772 15.5923 1 15.099 1C14.6058 1 14.2059 1.44772 14.2059 2Z"
        stroke="#CBD5E0"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function DeleteIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.79373 2.20143C5.79373 1.06224 6.71811 0.138733 7.85839 0.138733C8.99867 0.138733 9.92305 1.06224 9.92305 2.20143V2.32569C11.7137 2.54339 13.3865 3.04 14.8621 3.75843C15.1417 3.89454 15.2579 4.23128 15.1216 4.51058C14.9854 4.78987 14.6483 4.90594 14.3688 4.76984C12.4981 3.85908 10.2641 3.32654 7.85838 3.32654C5.45267 3.32654 3.21866 3.85908 1.34798 4.76984C1.06842 4.90594 0.731354 4.78987 0.59512 4.51058C0.458885 4.23128 0.575072 3.89454 0.854629 3.75843C2.33029 3.03999 4.00312 2.54339 5.79373 2.32568V2.20143ZM12.563 12.3522C12.4508 13.9223 11.1431 15.1387 9.5675 15.1387H6.15064C4.57508 15.1387 3.26738 13.9223 3.15513 12.3522L2.63842 5.12514C4.22808 4.57136 5.99617 4.26267 7.85907 4.26267C9.72198 4.26267 11.4901 4.57136 13.0797 5.12514L12.563 12.3522ZM6.92059 6.88793C6.92059 6.57723 6.66849 6.32537 6.3575 6.32537C6.04652 6.32537 5.79441 6.57723 5.79441 6.88793V11.3884C5.79441 11.6991 6.04652 11.9509 6.3575 11.9509C6.66849 11.9509 6.92059 11.6991 6.92059 11.3884V6.88793ZM9.36065 6.32537C9.67163 6.32537 9.92374 6.57723 9.92374 6.88793V11.3884C9.92374 11.6991 9.67163 11.9509 9.36065 11.9509C9.04966 11.9509 8.79756 11.6991 8.79756 11.3884V6.88793C8.79756 6.57723 9.04966 6.32537 9.36065 6.32537Z"
        fill="#FF7CA3"
      />
    </svg>
  );
}

export function CouponCart({ size, color, title, children }) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.576172"
        y="0.356567"
        width="27.3154"
        height="27.3154"
        rx="8.19462"
        fill="#BDC167"
      />
      <path
        d="M21.6995 10.3453C21.4371 10.2918 21.1961 10.1623 21.0067 9.97287C20.8173 9.78345 20.6878 9.54252 20.6342 9.28005C20.5923 9.07439 20.4805 8.88955 20.3179 8.75681C20.1553 8.62407 19.9518 8.55159 19.7419 8.55164H11.5018V9.46215C11.5018 9.58289 11.4538 9.69869 11.3684 9.78406C11.2831 9.86944 11.1673 9.91741 11.0465 9.91741C10.9258 9.91741 10.81 9.86944 10.7246 9.78406C10.6392 9.69869 10.5913 9.58289 10.5913 9.46215V8.55164H9.63523C9.42533 8.55159 9.22186 8.62407 9.05926 8.75681C8.89666 8.88955 8.78491 9.07439 8.74293 9.28005C8.6894 9.54252 8.55987 9.78345 8.37045 9.97287C8.18104 10.1623 7.9401 10.2918 7.67763 10.3453C7.47197 10.3873 7.28713 10.4991 7.15439 10.6617C7.02166 10.8243 6.94918 11.0277 6.94922 11.2377V17.7023C6.94918 17.9122 7.02166 18.1157 7.15439 18.2783C7.28713 18.4409 7.47197 18.5526 7.67763 18.5946C7.9401 18.6481 8.18104 18.7777 8.37045 18.9671C8.55987 19.1565 8.6894 19.3974 8.74293 19.6599C8.78491 19.8656 8.89666 20.0504 9.05926 20.1831C9.22186 20.3159 9.42533 20.3884 9.63523 20.3883H10.5913V19.4778C10.5913 19.3571 10.6392 19.2413 10.7246 19.1559C10.81 19.0705 10.9258 19.0225 11.0465 19.0225C11.1673 19.0225 11.2831 19.0705 11.3684 19.1559C11.4538 19.2413 11.5018 19.3571 11.5018 19.4778V20.3883H19.7419C19.9518 20.3884 20.1553 20.3159 20.3179 20.1831C20.4805 20.0504 20.5923 19.8656 20.6342 19.6599C20.6878 19.3974 20.8173 19.1565 21.0067 18.9671C21.1961 18.7777 21.4371 18.6481 21.6995 18.5946C21.9052 18.5526 22.09 18.4409 22.2228 18.2783C22.3555 18.1157 22.428 17.9122 22.4279 17.7023V11.2377C22.428 11.0277 22.3555 10.8243 22.2228 10.6617C22.09 10.4991 21.9052 10.3873 21.6995 10.3453ZM11.5018 17.7251C11.5018 17.8458 11.4538 17.9616 11.3684 18.047C11.2831 18.1324 11.1673 18.1803 11.0465 18.1803C10.9258 18.1803 10.81 18.1324 10.7246 18.047C10.6392 17.9616 10.5913 17.8458 10.5913 17.7251V16.7235C10.5913 16.6028 10.6392 16.487 10.7246 16.4016C10.81 16.3162 10.9258 16.2682 11.0465 16.2682C11.1673 16.2682 11.2831 16.3162 11.3684 16.4016C11.4538 16.487 11.5018 16.6028 11.5018 16.7235V17.7251ZM11.5018 14.9708C11.5018 15.0915 11.4538 15.2073 11.3684 15.2927C11.2831 15.378 11.1673 15.426 11.0465 15.426C10.9258 15.426 10.81 15.378 10.7246 15.2927C10.6392 15.2073 10.5913 15.0915 10.5913 14.9708V13.9692C10.5913 13.8484 10.6392 13.7327 10.7246 13.6473C10.81 13.5619 10.9258 13.5139 11.0465 13.5139C11.1673 13.5139 11.2831 13.5619 11.3684 13.6473C11.4538 13.7327 11.5018 13.8484 11.5018 13.9692V14.9708ZM11.5018 12.2155C11.5018 12.3363 11.4538 12.4521 11.3684 12.5375C11.2831 12.6228 11.1673 12.6708 11.0465 12.6708C10.9258 12.6708 10.81 12.6228 10.7246 12.5375C10.6392 12.4521 10.5913 12.3363 10.5913 12.2155V11.214C10.5913 11.0932 10.6392 10.9774 10.7246 10.8921C10.81 10.8067 10.9258 10.7587 11.0465 10.7587C11.1673 10.7587 11.2831 10.8067 11.3684 10.8921C11.4538 10.9774 11.5018 11.0932 11.5018 11.214V12.2155ZM16.5096 12.6489C16.5081 13.0515 16.3733 13.4422 16.1261 13.76C15.879 14.0777 15.5336 14.3047 15.1438 14.4053V17.6568C15.1438 17.7775 15.0959 17.8933 15.0105 17.9787C14.9251 18.0641 14.8093 18.112 14.6886 18.112C14.5678 18.112 14.452 18.0641 14.3667 17.9787C14.2813 17.8933 14.2333 17.7775 14.2333 17.6568V14.4053C13.8436 14.3047 13.4981 14.0777 13.251 13.76C13.0039 13.4422 12.8691 13.0515 12.8676 12.6489V11.2832C12.8676 11.1624 12.9155 11.0466 13.0009 10.9613C13.0863 10.8759 13.2021 10.8279 13.3228 10.8279C13.4436 10.8279 13.5594 10.8759 13.6447 10.9613C13.7301 11.0466 13.7781 11.1624 13.7781 11.2832V12.6489C13.7799 12.806 13.8229 12.9597 13.9028 13.0949C13.9827 13.2301 14.0967 13.3419 14.2333 13.4192V11.2832C14.2333 11.1624 14.2813 11.0466 14.3667 10.9613C14.452 10.8759 14.5678 10.8279 14.6886 10.8279C14.8093 10.8279 14.9251 10.8759 15.0105 10.9613C15.0959 11.0466 15.1438 11.1624 15.1438 11.2832V13.4192C15.2805 13.3419 15.3945 13.2301 15.4744 13.0949C15.5543 12.9597 15.5973 12.806 15.5991 12.6489V11.2832C15.5991 11.1624 15.6471 11.0466 15.7324 10.9613C15.8178 10.8759 15.9336 10.8279 16.0544 10.8279C16.1751 10.8279 16.2909 10.8759 16.3763 10.9613C16.4616 11.0466 16.5096 11.1624 16.5096 11.2832V12.6489ZM19.639 15.9177L18.3306 16.5723V17.6568C18.3306 17.7775 18.2827 17.8933 18.1973 17.9787C18.1119 18.0641 17.9961 18.112 17.8754 18.112C17.7546 18.112 17.6388 18.0641 17.5535 17.9787C17.4681 17.8933 17.4201 17.7775 17.4201 17.6568V11.2832C17.42 11.193 17.4466 11.1048 17.4966 11.0298C17.5466 10.9548 17.6178 10.8963 17.701 10.8618C17.7843 10.8273 17.876 10.8183 17.9644 10.8359C18.0528 10.8535 18.134 10.897 18.1977 10.9609C19.3419 12.0285 20.0372 13.4913 20.1426 15.0527C20.1523 15.2303 20.1098 15.4069 20.0203 15.5606C19.9308 15.7143 19.7983 15.8385 19.639 15.9177Z"
        fill="white"
      />
      <rect x="12.0898" y="9.99963" width="9" height="9" fill="white" />
      <path
        d="M13.2148 15.9987H19.9648M13.2148 15.9987V17.1237H19.9648V15.9987M13.2148 15.9987V14.8737C13.2148 13.0098 14.7259 11.4987 16.5898 11.4987M19.9648 15.9987V14.8737C19.9648 13.0098 18.4538 11.4987 16.5898 11.4987M16.5898 11.4987V12.6237M16.5898 12.6237C17.8325 12.6237 18.8398 13.6311 18.8398 14.8737V15.9987H14.3398V14.8737C14.3398 13.6311 15.3472 12.6237 16.5898 12.6237ZM19.7773 14.6862H18.8398M14.3398 14.6862H13.4023M14.7776 13.6399L13.8294 13.0925M15.5779 12.9335L14.9961 11.9258M17.6018 12.9335L18.1836 11.9258M18.402 13.6399L19.3503 13.0925M17.0174 13.6504C17.399 14.2707 17.5898 14.7201 17.5898 14.9987C17.5898 15.551 17.1421 15.9987 16.5898 15.9987C16.0376 15.9987 15.5898 15.551 15.5898 14.9987C15.5898 14.8701 15.6305 14.7051 15.7118 14.5037L16.3217 14.8556L17.0174 13.6504Z"
        stroke="#BDC167"
        strokeWidth="0.375"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function TwitterIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M2.5 0.25C1.12109 0.25 0 1.37109 0 2.75V15.25C0 16.6289 1.12109 17.75 2.5 17.75H15C16.3789 17.75 17.5 16.6289 17.5 15.25V2.75C17.5 1.37109 16.3789 0.25 15 0.25H2.5ZM14.1055 3.53125L10.0508 8.16406L14.8203 14.4688H11.0859L8.16406 10.6445L4.81641 14.4688H2.96094L7.29688 9.51172L2.72266 3.53125H6.55078L9.19531 7.02734L12.25 3.53125H14.1055ZM12.6289 13.3594L5.99219 4.58203H4.88672L11.5977 13.3594H12.625H12.6289Z"
        fill="black"
      />
    </svg>
  );
}

export function Tiktok({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
    >
      <g clip-path="url(#clip0_689_21321)">
        <path
          d="M13.0841 7.20142C14.3723 8.12177 15.9503 8.66328 17.6547 8.66328V5.38535C17.3321 5.38542 17.0104 5.35177 16.6948 5.28494V7.86515C14.9906 7.86515 13.4127 7.3237 12.1243 6.40342V13.0928C12.1243 16.4392 9.41012 19.1518 6.06226 19.1518C4.81309 19.1518 3.65198 18.7743 2.6875 18.1269C3.78833 19.252 5.3235 19.9498 7.02184 19.9498C10.37 19.9498 13.0843 17.2373 13.0843 13.8907V7.20142H13.0841ZM14.2683 3.89439C13.6099 3.17556 13.1776 2.24659 13.0841 1.21956V0.797974H12.1745C12.4035 2.10328 13.1845 3.21846 14.2683 3.89439ZM4.80502 15.5591C4.43722 15.0771 4.2384 14.4874 4.23929 13.8811C4.23929 12.3507 5.48074 11.1097 7.0124 11.1097C7.29779 11.1096 7.58151 11.1534 7.85357 11.2396V7.88832C7.53564 7.8448 7.21481 7.82625 6.89412 7.83308V10.4415C6.62193 10.3552 6.33807 10.3114 6.05253 10.3117C4.52095 10.3117 3.27957 11.5525 3.27957 13.0832C3.27957 14.1656 3.90005 15.1026 4.80502 15.5591Z"
          fill="#FF004F"
        />
        <path
          d="M12.1235 6.40335C13.412 7.32363 14.9897 7.86508 16.694 7.86508V5.28487C15.7427 5.08232 14.9006 4.58549 14.2674 3.89439C13.1836 3.21839 12.4027 2.10322 12.1737 0.797974H9.78457V13.8906C9.77912 15.4169 8.53981 16.6528 7.01147 16.6528C6.11092 16.6528 5.31078 16.2238 4.80409 15.559C3.89926 15.1026 3.27871 14.1655 3.27871 13.0833C3.27871 11.5527 4.52009 10.3118 6.05167 10.3118C6.34512 10.3118 6.62795 10.3574 6.89326 10.4416V7.83315C3.60416 7.90108 0.958984 10.5871 0.958984 13.8907C0.958984 15.5398 1.61767 17.0347 2.68678 18.1271C3.65126 18.7743 4.81229 19.1519 6.06154 19.1519C9.40947 19.1519 12.1236 16.4391 12.1236 13.0928L12.1235 6.40335Z"
          fill="black"
        />
        <path
          d="M16.6948 5.28483V4.58731C15.837 4.58861 14.996 4.34849 14.2682 3.89441C14.9125 4.59939 15.7609 5.08554 16.6948 5.28497M12.1745 0.797931C12.1527 0.673214 12.1359 0.547663 12.1243 0.421586V0H8.82538V13.0928C8.82014 14.619 7.58083 15.8548 6.05241 15.8548C5.61912 15.8555 5.19175 15.7542 4.80483 15.5592C5.31152 16.2238 6.11165 16.6528 7.01221 16.6528C8.54048 16.6528 9.77993 15.417 9.78531 13.8907V0.798L12.1745 0.797931ZM6.89421 7.8331V7.09041C6.61855 7.05273 6.34064 7.03389 6.06241 7.034C2.71414 7.034 0 9.74669 0 13.0928C0 15.1906 1.06669 17.0394 2.68765 18.127C1.61855 17.0347 0.959862 15.5397 0.959862 13.8906C0.959862 10.5872 3.60497 7.90103 6.89421 7.8331Z"
          fill="#00F2EA"
        />
      </g>
      <defs>
        <clipPath id="clip0_689_21321">
          <rect width="17.6552" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function Facebook({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clip-path="url(#clip0_689_21325)">
        <path
          d="M18.2258 0.754639H1.77422C1.21072 0.754639 0.753906 1.21145 0.753906 1.77495V18.2265C0.753906 18.79 1.21072 19.2468 1.77422 19.2468H18.2258C18.7893 19.2468 19.2461 18.79 19.2461 18.2265V1.77495C19.2461 1.21145 18.7893 0.754639 18.2258 0.754639Z"
          fill="#3D5A98"
        />
        <path
          d="M13.5133 19.2453V12.0844H15.9164L16.2758 9.29377H13.5133V7.51252C13.5133 6.7047 13.7383 6.15314 14.8961 6.15314H16.3742V3.65314C15.6584 3.57868 14.9392 3.54321 14.2195 3.54689C12.0914 3.54689 10.6258 4.84377 10.6258 7.23595V9.29377H8.22266V12.0844H10.6258V19.2453H13.5133Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_689_21325">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function WarningIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0003 18.3333C14.6027 18.3333 18.3337 14.6024 18.3337 10C18.3337 5.39763 14.6027 1.66667 10.0003 1.66667C5.39795 1.66667 1.66699 5.39763 1.66699 10C1.66699 14.6024 5.39795 18.3333 10.0003 18.3333ZM10.6253 6.66667C10.6253 6.32149 10.3455 6.04167 10.0003 6.04167C9.65515 6.04167 9.37533 6.32149 9.37533 6.66667V7.50001C9.37533 7.84518 9.65515 8.12501 10.0003 8.12501C10.3455 8.12501 10.6253 7.84518 10.6253 7.50001V6.66667ZM10.6253 9.58334C10.6253 9.23816 10.3455 8.95834 10.0003 8.95834C9.65515 8.95834 9.37533 9.23816 9.37533 9.58334V13.3333C9.37533 13.6785 9.65515 13.9583 10.0003 13.9583C10.3455 13.9583 10.6253 13.6785 10.6253 13.3333V9.58334Z"
        fill="#888C3F"
      />
    </svg>
  );
}

export function FileIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10.5302 7.32028H14.9189L10.5302 2.93155V7.32028ZM4.94454 1.73462H11.3281L16.1159 6.52233V16.0977C16.1159 16.521 15.9477 16.9269 15.6484 17.2262C15.3491 17.5255 14.9432 17.6936 14.52 17.6936H4.94454C4.05881 17.6936 3.34863 16.9755 3.34863 16.0977V3.33052C3.34863 2.4448 4.05881 1.73462 4.94454 1.73462ZM12.1261 14.5018V12.9059H4.94454V14.5018H12.1261ZM14.52 11.31V9.71413H4.94454V11.31H14.52Z"
        fill="#252A4D"
      />
    </svg>
  );
}

export function CACDeleteIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
    >
      <path
        d="M13.2096 7.05278L12.7211 13.4039C12.6117 14.826 11.4258 15.9242 9.99948 15.9242H6.866C5.43966 15.9242 4.25378 14.826 4.14439 13.4039L3.65584 7.05278M14.5745 5.68795C12.8016 4.824 10.694 4.32312 8.43274 4.32312C6.17146 4.32312 4.06387 4.824 2.29102 5.68795M7.06791 4.32312V3.64071C7.06791 2.88693 7.67897 2.27588 8.43274 2.27588C9.18651 2.27588 9.79757 2.88693 9.79757 3.64071V4.32312M7.06791 8.4176V12.5121M9.79757 8.4176V12.5121"
        stroke="#FF753B"
        strokeWidth="1.02362"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function InfoIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.97461 13.3148C10.736 13.3148 12.9746 11.0762 12.9746 8.31476C12.9746 5.55333 10.736 3.31476 7.97461 3.31476C5.21319 3.31476 2.97461 5.55333 2.97461 8.31476C2.97461 11.0762 5.21319 13.3148 7.97461 13.3148ZM7.97461 6.62726C8.07816 6.62726 8.16211 6.54331 8.16211 6.43976C8.16211 6.33621 8.07816 6.25226 7.97461 6.25226C7.87106 6.25226 7.78711 6.33621 7.78711 6.43976C7.78711 6.54331 7.87106 6.62726 7.97461 6.62726ZM7.16211 6.43976C7.16211 5.99103 7.52588 5.62726 7.97461 5.62726C8.42334 5.62726 8.78711 5.99103 8.78711 6.43976C8.78711 6.88849 8.42334 7.25226 7.97461 7.25226C7.52588 7.25226 7.16211 6.88849 7.16211 6.43976ZM7.97461 7.93976C8.52689 7.93976 8.97461 8.38747 8.97461 8.93976V10.1898C8.97461 10.742 8.52689 11.1898 7.97461 11.1898C7.42232 11.1898 6.97461 10.742 6.97461 10.1898V8.93976C6.97461 8.38747 7.42232 7.93976 7.97461 7.93976Z"
        fill={color ? color : "#252A4D"}
      />
    </svg>
  );
}

export function LocationOutlineIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M13.7489 6.99772C13.6546 6.03924 13.3076 5.12096 12.7417 4.33227C12.1759 3.54358 11.4104 2.91138 10.52 2.49722C9.6295 2.08307 8.64434 1.90107 7.66042 1.96895C6.6765 2.03684 5.72736 2.35229 4.90541 2.8846C4.19927 3.34553 3.60647 3.95342 3.1696 4.66458C2.73272 5.37575 2.46262 6.17254 2.37869 6.99772C2.29636 7.81749 2.40199 8.64488 2.68793 9.41985C2.97386 10.1948 3.43292 10.8979 4.03181 11.4782L7.59341 14.9616C7.65588 15.023 7.73021 15.0718 7.8121 15.1052C7.89398 15.1385 7.98182 15.1556 8.07053 15.1556C8.15924 15.1556 8.24708 15.1385 8.32897 15.1052C8.41086 15.0718 8.48518 15.023 8.54765 14.9616L12.0958 11.4782C12.6947 10.8979 13.1538 10.1948 13.4397 9.41985C13.7256 8.64488 13.8313 7.81749 13.7489 6.99772ZM11.155 10.5532L8.06381 13.5708L4.97261 10.5532C4.51706 10.1085 4.16809 9.57077 3.95081 8.97868C3.73353 8.38659 3.65333 7.75487 3.71597 7.12892C3.77902 6.49332 3.98596 5.87934 4.32183 5.33137C4.6577 4.78341 5.1141 4.31514 5.65805 3.96044C6.37101 3.49811 7.20789 3.25149 8.06381 3.25149C8.91973 3.25149 9.75662 3.49811 10.4696 3.96044C11.0119 4.31377 11.4673 4.77997 11.8031 5.32553C12.1388 5.8711 12.3467 6.4825 12.4117 7.1158C12.4763 7.74387 12.3971 8.37812 12.1798 8.97264C11.9625 9.56715 11.6124 10.107 11.155 10.5532ZM8.06381 4.61644C7.46572 4.61644 6.88106 4.78957 6.38377 5.11394C5.88647 5.43831 5.49888 5.89935 5.27 6.43876C5.04112 6.97816 4.98123 7.57171 5.09792 8.14434C5.2146 8.71698 5.50261 9.24297 5.92552 9.65582C6.34843 10.0687 6.88726 10.3498 7.47386 10.4637C8.06046 10.5776 8.66848 10.5192 9.22105 10.2957C9.77361 10.0723 10.2459 9.69393 10.5782 9.20848C10.9105 8.72303 11.0878 8.15229 11.0878 7.56844C11.086 6.78605 10.7669 6.0362 10.2001 5.48297C9.63342 4.92974 8.86528 4.61817 8.06381 4.61644ZM8.06381 9.20844C7.73154 9.20844 7.40673 9.11225 7.13045 8.93205C6.85418 8.75184 6.63885 8.49571 6.51169 8.19604C6.38454 7.89637 6.35127 7.56662 6.41609 7.24849C6.48092 6.93036 6.64092 6.63814 6.87587 6.40878C7.11082 6.17942 7.41017 6.02323 7.73606 5.95995C8.06195 5.89667 8.39974 5.92915 8.70672 6.05327C9.0137 6.1774 9.27608 6.38761 9.46068 6.6573C9.64528 6.927 9.74381 7.24408 9.74381 7.56844C9.74381 8.00339 9.56681 8.42053 9.25175 8.72809C8.93669 9.03565 8.50937 9.20844 8.06381 9.20844Z"
        fill="#BDC167"
      />
    </svg>
  );
}

export function GreenDot({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
    >
      <circle
        cx="6.6117"
        cy="6.50019"
        r="6.5"
        transform="rotate(2.42524 6.6117 6.50019)"
        fill="#2D9556"
      />
    </svg>
  );
}

export function CountDownTimer({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M6.92681 4.89883C7.33281 4.49282 7.35253 3.82853 6.84295 3.6297C6.5344 3.5093 6.20163 3.45231 5.86364 3.46199C5.52566 3.47167 5.18908 3.54783 4.87311 3.68612C4.55715 3.8244 4.268 4.02211 4.02216 4.26794C3.77632 4.51378 3.57862 4.80293 3.44033 5.1189C3.30205 5.43486 3.22589 5.77144 3.21621 6.10943C3.20653 6.44741 3.26352 6.78018 3.38392 7.08873C3.58275 7.59831 4.24704 7.5786 4.65305 7.17259L6.92681 4.89883Z"
        fill="#D8D5D5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22.5001C16.9706 22.5001 21 18.4706 21 13.5001C21 8.5295 16.9706 4.50006 12 4.50006C7.02944 4.50006 3 8.5295 3 13.5001C3 18.4706 7.02944 22.5001 12 22.5001ZM12.75 8.50006C12.75 8.08585 12.4142 7.75006 12 7.75006C11.5858 7.75006 11.25 8.08585 11.25 8.50006V14.5001C11.25 14.9143 11.5858 15.2501 12 15.2501H16C16.4142 15.2501 16.75 14.9143 16.75 14.5001C16.75 14.0859 16.4142 13.7501 16 13.7501H12.75V8.50006Z"
        fill="#D8D5D5"
      />
      <path
        d="M17.1614 3.6297C16.6518 3.82853 16.6715 4.49282 17.0775 4.89883L19.3513 7.17259C19.7573 7.5786 20.4216 7.59831 20.6204 7.08873C20.7408 6.78018 20.7978 6.44741 20.7881 6.10943C20.7784 5.77144 20.7023 5.43486 20.564 5.1189C20.4257 4.80293 20.228 4.51378 19.9822 4.26794C19.7363 4.02211 19.4472 3.8244 19.1312 3.68612C18.8153 3.54783 18.4787 3.47167 18.1407 3.46199C17.8027 3.45231 17.4699 3.5093 17.1614 3.6297Z"
        fill="#D8D5D5"
      />
    </svg>
  );
}

export function SuccessIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22.5C17.5228 22.5 22 18.0228 22 12.5C22 6.97715 17.5228 2.5 12 2.5C6.47715 2.5 2 6.97715 2 12.5C2 18.0228 6.47715 22.5 12 22.5ZM16.7803 10.2803C17.0732 9.98744 17.0732 9.51256 16.7803 9.21967C16.4874 8.92678 16.0126 8.92678 15.7197 9.21967L10.75 14.1893L8.28033 11.7197C7.98744 11.4268 7.51256 11.4268 7.21967 11.7197C6.92678 12.0126 6.92678 12.4874 7.21967 12.7803L10.2197 15.7803C10.5126 16.0732 10.9874 16.0732 11.2803 15.7803L16.7803 10.2803Z"
        fill="#2D9556"
      />
    </svg>
  );
}

export function EarPhoneIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
    >
      <path
        d="M7.10078 2.36904C4.99865 2.36904 3.29453 4.07316 3.29453 6.17529V8.80029C3.29453 9.3077 2.88319 9.71904 2.37578 9.71904C1.86837 9.71904 1.45703 9.3077 1.45703 8.80029V7.75029C1.45703 7.08944 1.90105 6.53228 2.50703 6.36089V6.17529C2.50703 3.63823 4.56372 1.58154 7.10078 1.58154C9.63784 1.58154 11.6945 3.63823 11.6945 6.17529V6.36089C12.3005 6.53228 12.7445 7.08944 12.7445 7.75029V8.80029C12.7445 9.3077 12.3332 9.71904 11.8258 9.71904C11.6805 9.71904 11.543 9.68531 11.4209 9.62525C10.8833 10.34 9.65511 11.1841 7.52604 11.2842C7.39134 11.525 7.13382 11.6878 6.83828 11.6878C6.40336 11.6878 6.05078 11.3352 6.05078 10.9003C6.05078 10.4654 6.40336 10.1128 6.83828 10.1128C7.12557 10.1128 7.37693 10.2666 7.51447 10.4964C9.75222 10.3852 10.7013 9.38399 10.9192 8.94992C10.9112 8.90123 10.907 8.85124 10.907 8.80029V6.17529C10.907 4.07316 9.20292 2.36904 7.10078 2.36904Z"
        fill="#2B315A"
      />
    </svg>
  );
}

export function BuildingIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
    >
      <g clip-path="url(#clip0_1763_15358)">
        <path
          d="M5.75391 10.999C5.75391 11.1979 5.67489 11.3887 5.53424 11.5294C5.39358 11.67 5.20282 11.749 5.00391 11.749H4.25391C4.05499 11.749 3.86423 11.67 3.72358 11.5294C3.58292 11.3887 3.50391 11.1979 3.50391 10.999C3.50391 10.8001 3.58292 10.6093 3.72358 10.4687C3.86423 10.328 4.05499 10.249 4.25391 10.249H5.00391C5.20282 10.249 5.39358 10.328 5.53424 10.4687C5.67489 10.6093 5.75391 10.8001 5.75391 10.999ZM8.75391 10.249H8.00391C7.80499 10.249 7.61423 10.328 7.47358 10.4687C7.33292 10.6093 7.25391 10.8001 7.25391 10.999C7.25391 11.1979 7.33292 11.3887 7.47358 11.5294C7.61423 11.67 7.80499 11.749 8.00391 11.749H8.75391C8.95282 11.749 9.14358 11.67 9.28424 11.5294C9.42489 11.3887 9.50391 11.1979 9.50391 10.999C9.50391 10.8001 9.42489 10.6093 9.28424 10.4687C9.14358 10.328 8.95282 10.249 8.75391 10.249ZM5.00391 13.249H4.25391C4.05499 13.249 3.86423 13.328 3.72358 13.4687C3.58292 13.6093 3.50391 13.8001 3.50391 13.999C3.50391 14.1979 3.58292 14.3887 3.72358 14.5294C3.86423 14.67 4.05499 14.749 4.25391 14.749H5.00391C5.20282 14.749 5.39358 14.67 5.53424 14.5294C5.67489 14.3887 5.75391 14.1979 5.75391 13.999C5.75391 13.8001 5.67489 13.6093 5.53424 13.4687C5.39358 13.328 5.20282 13.249 5.00391 13.249ZM8.75391 13.249H8.00391C7.80499 13.249 7.61423 13.328 7.47358 13.4687C7.33292 13.6093 7.25391 13.8001 7.25391 13.999C7.25391 14.1979 7.33292 14.3887 7.47358 14.5294C7.61423 14.67 7.80499 14.749 8.00391 14.749H8.75391C8.95282 14.749 9.14358 14.67 9.28424 14.5294C9.42489 14.3887 9.50391 14.1979 9.50391 13.999C9.50391 13.8001 9.42489 13.6093 9.28424 13.4687C9.14358 13.328 8.95282 13.249 8.75391 13.249ZM5.00391 4.24902H4.25391C4.05499 4.24902 3.86423 4.32804 3.72358 4.46869C3.58292 4.60935 3.50391 4.80011 3.50391 4.99902C3.50391 5.19794 3.58292 5.3887 3.72358 5.52935C3.86423 5.67001 4.05499 5.74902 4.25391 5.74902H5.00391C5.20282 5.74902 5.39358 5.67001 5.53424 5.52935C5.67489 5.3887 5.75391 5.19794 5.75391 4.99902C5.75391 4.80011 5.67489 4.60935 5.53424 4.46869C5.39358 4.32804 5.20282 4.24902 5.00391 4.24902ZM8.75391 4.24902H8.00391C7.80499 4.24902 7.61423 4.32804 7.47358 4.46869C7.33292 4.60935 7.25391 4.80011 7.25391 4.99902C7.25391 5.19794 7.33292 5.3887 7.47358 5.52935C7.61423 5.67001 7.80499 5.74902 8.00391 5.74902H8.75391C8.95282 5.74902 9.14358 5.67001 9.28424 5.52935C9.42489 5.3887 9.50391 5.19794 9.50391 4.99902C9.50391 4.80011 9.42489 4.60935 9.28424 4.46869C9.14358 4.32804 8.95282 4.24902 8.75391 4.24902ZM5.00391 7.24902H4.25391C4.05499 7.24902 3.86423 7.32804 3.72358 7.46869C3.58292 7.60935 3.50391 7.80011 3.50391 7.99902C3.50391 8.19794 3.58292 8.3887 3.72358 8.52935C3.86423 8.67 4.05499 8.74902 4.25391 8.74902H5.00391C5.20282 8.74902 5.39358 8.67 5.53424 8.52935C5.67489 8.3887 5.75391 8.19794 5.75391 7.99902C5.75391 7.80011 5.67489 7.60935 5.53424 7.46869C5.39358 7.32804 5.20282 7.24902 5.00391 7.24902ZM8.75391 7.24902H8.00391C7.80499 7.24902 7.61423 7.32804 7.47358 7.46869C7.33292 7.60935 7.25391 7.80011 7.25391 7.99902C7.25391 8.19794 7.33292 8.3887 7.47358 8.52935C7.61423 8.67 7.80499 8.74902 8.00391 8.74902H8.75391C8.95282 8.74902 9.14358 8.67 9.28424 8.52935C9.42489 8.3887 9.50391 8.19794 9.50391 7.99902C9.50391 7.80011 9.42489 7.60935 9.28424 7.46869C9.14358 7.32804 8.95282 7.24902 8.75391 7.24902ZM18.5039 7.99902V14.749C18.5027 15.7432 18.1072 16.6964 17.4042 17.3994C16.7012 18.1024 15.7481 18.4978 14.7539 18.499H4.25391C3.25971 18.4978 2.30657 18.1024 1.60357 17.3994C0.900568 16.6964 0.505097 15.7432 0.503906 14.749L0.503906 4.24902C0.505097 3.25483 0.900568 2.30169 1.60357 1.59869C2.30657 0.895685 3.25971 0.500214 4.25391 0.499023L8.75391 0.499023C9.7481 0.500214 10.7012 0.895685 11.4042 1.59869C12.1072 2.30169 12.5027 3.25483 12.5039 4.24902H14.7539C15.7481 4.25021 16.7012 4.64568 17.4042 5.34869C18.1072 6.05169 18.5027 7.00483 18.5039 7.99902ZM4.25391 16.999H11.0039V4.24902C11.0039 3.65229 10.7669 3.07999 10.3449 2.65803C9.92294 2.23608 9.35064 1.99902 8.75391 1.99902H4.25391C3.65717 1.99902 3.08487 2.23608 2.66292 2.65803C2.24096 3.07999 2.00391 3.65229 2.00391 4.24902V14.749C2.00391 15.3458 2.24096 15.9181 2.66292 16.34C3.08487 16.762 3.65717 16.999 4.25391 16.999ZM17.0039 7.99902C17.0039 7.40229 16.7669 6.82999 16.3449 6.40803C15.9229 5.98608 15.3506 5.74902 14.7539 5.74902H12.5039V16.999H14.7539C15.3506 16.999 15.9229 16.762 16.3449 16.34C16.7669 15.9181 17.0039 15.3458 17.0039 14.749V7.99902ZM14.7539 10.249C14.6056 10.249 14.4606 10.293 14.3372 10.3754C14.2139 10.4578 14.1178 10.575 14.061 10.712C14.0042 10.8491 13.9894 10.9999 14.0183 11.1453C14.0473 11.2908 14.1187 11.4245 14.2236 11.5294C14.3285 11.6342 14.4621 11.7057 14.6076 11.7346C14.7531 11.7636 14.9039 11.7487 15.0409 11.6919C15.178 11.6352 15.2951 11.539 15.3775 11.4157C15.4599 11.2924 15.5039 11.1474 15.5039 10.999C15.5039 10.8001 15.4249 10.6093 15.2842 10.4687C15.1436 10.328 14.9528 10.249 14.7539 10.249ZM14.7539 13.249C14.6056 13.249 14.4606 13.293 14.3372 13.3754C14.2139 13.4578 14.1178 13.575 14.061 13.712C14.0042 13.8491 13.9894 13.9999 14.0183 14.1453C14.0473 14.2908 14.1187 14.4245 14.2236 14.5294C14.3285 14.6342 14.4621 14.7057 14.6076 14.7346C14.7531 14.7635 14.9039 14.7487 15.0409 14.6919C15.178 14.6352 15.2951 14.539 15.3775 14.4157C15.4599 14.2924 15.5039 14.1474 15.5039 13.999C15.5039 13.8001 15.4249 13.6093 15.2842 13.4687C15.1436 13.328 14.9528 13.249 14.7539 13.249ZM14.7539 7.24902C14.6056 7.24902 14.4606 7.29301 14.3372 7.37542C14.2139 7.45783 14.1178 7.57497 14.061 7.71201C14.0042 7.84905 13.9894 7.99986 14.0183 8.14534C14.0473 8.29083 14.1187 8.42446 14.2236 8.52935C14.3285 8.63424 14.4621 8.70567 14.6076 8.73461C14.7531 8.76355 14.9039 8.7487 15.0409 8.69193C15.178 8.63517 15.2951 8.53904 15.3775 8.4157C15.4599 8.29236 15.5039 8.14736 15.5039 7.99902C15.5039 7.80011 15.4249 7.60935 15.2842 7.46869C15.1436 7.32804 14.9528 7.24902 14.7539 7.24902Z"
          fill="#2B315A"
        />
      </g>
      <defs>
        <clipPath id="clip0_1763_15358">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(0.503906 0.499023)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function EmailIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
    >
      <path
        d="M6.69835 0.5L4.36157 1.96281H2.3595V3.20248L1.10124 4.00207C0.741736 4.21901 0.5 4.6095 0.5 5.06198V11.2603C0.5 11.5891 0.630608 11.9044 0.863091 12.1369C1.09557 12.3694 1.41089 12.5 1.73967 12.5H11.657C12.345 12.5 12.8967 11.9483 12.8967 11.2603V5.06198C12.8967 4.6095 12.655 4.21901 12.2955 4.00207L11.0372 3.20248V1.96281H9.03512M3.59917 3.20248H9.79752V6.22727L6.69835 8.16116L3.59917 6.22727M4.21901 3.82231V4.75207H9.17769V3.82231M2.3595 4.67769V5.45248L1.73967 5.06198M11.0372 4.67769L11.657 5.06198L11.0372 5.45248M4.21901 5.3719V6.30165H9.17769V5.3719H4.21901Z"
        fill="#505780"
      />
    </svg>
  );
}

export function DialIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
    >
      <path
        d="M3.39679 5.43C4.35671 7.52041 6.06237 9.17722 8.17979 10.076L8.51979 10.2275C8.8963 10.3952 9.31991 10.4246 9.71597 10.3105C10.112 10.1964 10.4551 9.94624 10.6848 9.604L11.1293 8.942C11.1988 8.83818 11.227 8.71208 11.2082 8.58853C11.1894 8.46499 11.1251 8.35295 11.0278 8.2745L9.52179 7.0595C9.46934 7.01722 9.40888 6.98597 9.34406 6.96763C9.27923 6.94929 9.21137 6.94425 9.14454 6.95279C9.07771 6.96134 9.0133 6.9833 8.95517 7.01736C8.89705 7.05142 8.8464 7.09688 8.80629 7.151L8.34029 7.7795C7.14409 7.18872 6.17585 6.22031 5.58528 5.024L6.21329 4.558C6.26741 4.51788 6.31286 4.46724 6.34693 4.40911C6.38099 4.35099 6.40295 4.28658 6.4115 4.21975C6.42004 4.15292 6.41499 4.08506 6.39666 4.02023C6.37832 3.9554 6.34707 3.89495 6.30479 3.8425L5.08978 2.3365C5.01133 2.23923 4.8993 2.17486 4.77575 2.15607C4.65221 2.13729 4.5261 2.16545 4.42229 2.235L3.75579 2.682C3.41149 2.91289 3.16033 3.25851 3.04706 3.65729C2.93379 4.05606 2.96577 4.4821 3.13729 4.8595L3.39679 5.43Z"
        fill="#505780"
      />
    </svg>
  );
}

export function BriefCaseIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clip-path="url(#clip0_2716_19285)">
        <path
          d="M6.66797 4.99935V4.16602C6.66797 2.7853 7.78726 1.66602 9.16797 1.66602H10.8346C12.2153 1.66602 13.3346 2.7853 13.3346 4.16602V4.99935M1.66797 8.62225C1.66797 8.62225 4.26634 10.353 8.31602 10.7584M18.3346 8.62225C18.3346 8.62225 15.7363 10.353 11.6866 10.7584M5.0013 18.3327H15.0013C16.8423 18.3327 18.3346 16.8403 18.3346 14.9993V8.33268C18.3346 6.49173 16.8423 4.99935 15.0013 4.99935H5.0013C3.16035 4.99935 1.66797 6.49173 1.66797 8.33268V14.9993C1.66797 16.8403 3.16035 18.3327 5.0013 18.3327Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M11.6654 10.1341V10.9674C11.6654 10.9758 11.6654 10.9758 11.6654 10.9841C11.6654 11.8924 11.657 12.6341 9.9987 12.6341C8.3487 12.6341 8.33203 11.9008 8.33203 10.9924V10.1341C8.33203 9.30078 8.33203 9.30078 9.16536 9.30078H10.832C11.6654 9.30078 11.6654 9.30078 11.6654 10.1341Z"
          stroke="white"
          strokeWidth="1.5"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2716_19285">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function UserIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M12.5846 5.83333C12.5846 7.26007 11.428 8.41667 10.0013 8.41667V9.91667C12.2565 9.91667 14.0846 8.0885 14.0846 5.83333H12.5846ZM10.0013 8.41667C8.57457 8.41667 7.41797 7.26007 7.41797 5.83333H5.91797C5.91797 8.0885 7.74614 9.91667 10.0013 9.91667V8.41667ZM7.41797 5.83333C7.41797 4.4066 8.57457 3.25 10.0013 3.25V1.75C7.74614 1.75 5.91797 3.57817 5.91797 5.83333H7.41797ZM10.0013 3.25C11.428 3.25 12.5846 4.4066 12.5846 5.83333H14.0846C14.0846 3.57817 12.2565 1.75 10.0013 1.75V3.25ZM15.0846 14.5833C15.0846 14.9516 14.7666 15.487 13.7907 15.9749C12.8596 16.4404 11.5209 16.75 10.0013 16.75V18.25C11.7033 18.25 13.2813 17.9067 14.4615 17.3165C15.5969 16.7489 16.5846 15.8259 16.5846 14.5833H15.0846ZM10.0013 16.75C8.48166 16.75 7.14296 16.4404 6.21192 15.9749C5.23603 15.487 4.91797 14.9516 4.91797 14.5833H3.41797C3.41797 15.8259 4.40575 16.7489 5.5411 17.3165C6.72132 17.9067 8.29928 18.25 10.0013 18.25V16.75ZM4.91797 14.5833C4.91797 14.215 5.23603 13.6797 6.21192 13.1918C7.14296 12.7262 8.48166 12.4167 10.0013 12.4167V10.9167C8.29928 10.9167 6.72132 11.26 5.5411 11.8501C4.40575 12.4178 3.41797 13.3408 3.41797 14.5833H4.91797ZM10.0013 12.4167C11.5209 12.4167 12.8596 12.7262 13.7907 13.1918C14.7666 13.6797 15.0846 14.215 15.0846 14.5833H16.5846C16.5846 13.3408 15.5969 12.4178 14.4615 11.8501C13.2813 11.26 11.7033 10.9167 10.0013 10.9167V12.4167Z"
        fill={color ?? "white"}
      />
    </svg>
  );
}

export function MoneyIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M16.6683 15.0007H11.6683M16.6683 15.0007C17.5887 15.0007 18.3349 15.7468 18.3349 16.6673C18.3349 17.5878 17.5887 18.334 16.6683 18.334H11.6683C10.7478 18.334 10.0016 17.5878 10.0016 16.6673C10.0016 15.7468 10.7478 15.0007 11.6683 15.0007M16.6683 15.0007C17.5887 15.0007 18.3349 14.2545 18.3349 13.334C18.3349 12.4135 17.5887 11.6673 16.6683 11.6673H16.1127M11.6683 15.0007C10.7478 15.0007 10.0016 14.2545 10.0016 13.334C10.0016 12.4135 10.7478 11.6673 11.6683 11.6673H16.1127M11.3978 18.334H8.6054C5.19261 18.334 2.78276 14.9905 3.86198 11.7528L4.69531 9.25284C5.37588 7.21113 7.28658 5.83398 9.43873 5.83398H10.5645C12.7166 5.83398 14.6273 7.21113 15.3079 9.25285L16.1127 11.6673"
        stroke="white"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M11.7395 5.83268L8.26306 5.83268L7.09549 4.49348C5.95096 3.1807 7.28618 1.2185 8.95719 1.75756L9.73034 2.00697C9.90636 2.06375 10.0962 2.06375 10.2723 2.00697L11.0454 1.75756C12.7164 1.2185 14.0516 3.18071 12.9071 4.49348L11.7395 5.83268Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function OrderIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <ellipse
        cx="9.16667"
        cy="3.33268"
        rx="1.66667"
        ry="1.66667"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M3.33203 8.33398V13.7646C3.33203 14.5221 3.76003 15.2147 4.4376 15.5534L9.10427 17.8868C9.66733 18.1683 10.3301 18.1683 10.8931 17.8868L15.5598 15.5534C16.2374 15.2147 16.6654 14.5221 16.6654 13.7646V8.33398"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M14.9987 4.16602L16.6654 4.99935L9.9987 8.33268L3.33203 4.99935L4.9987 4.16602"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6667 5L10 8.33333L11.6667 10.8333L18.3333 7.5L16.6667 5Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33333 5L10 8.33333L8.33333 10.8333L1.66667 7.5L3.33333 5Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.418 4.58398L11.2513 5.41732"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function ApplicationsIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M16.668 9.16667H3.33464M16.668 9.16667C17.5884 9.16667 18.3346 9.91286 18.3346 10.8333V14.1667C18.3346 16.0076 16.8423 17.5 15.0013 17.5H5.0013C3.16035 17.5 1.66797 16.0076 1.66797 14.1667V10.8333C1.66797 9.91286 2.41416 9.16667 3.33464 9.16667M16.668 9.16667V7.5C16.668 6.57953 15.9218 5.83333 15.0013 5.83333M3.33464 9.16667V7.5C3.33464 6.57953 4.08083 5.83333 5.0013 5.83333M15.0013 5.83333H5.0013M15.0013 5.83333V4.16667C15.0013 3.24619 14.2551 2.5 13.3346 2.5H6.66797C5.74749 2.5 5.0013 3.24619 5.0013 4.16667V5.83333M8.33464 11.6667H11.668"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
export function GetHelpIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clip-path="url(#clip0_2716_19325)">
        <path
          d="M11.4039 8.40001L12.0346 8.80585L12.0346 8.80585L11.4039 8.40001ZM7.58464 7.49935C7.58464 7.91356 7.92042 8.24935 8.33464 8.24935C8.74885 8.24935 9.08464 7.91356 9.08464 7.49935H7.58464ZM9.2513 11.2493C9.2513 11.6636 9.58709 11.9993 10.0013 11.9993C10.4155 11.9993 10.7513 11.6636 10.7513 11.2493H9.2513ZM10.7513 13.3327C10.7513 12.9185 10.4155 12.5827 10.0013 12.5827C9.58709 12.5827 9.2513 12.9185 9.2513 13.3327H10.7513ZM9.2513 14.166C9.2513 14.5802 9.58709 14.916 10.0013 14.916C10.4155 14.916 10.7513 14.5802 10.7513 14.166H9.2513ZM17.5846 9.99935C17.5846 14.1875 14.1895 17.5827 10.0013 17.5827V19.0827C15.0179 19.0827 19.0846 15.0159 19.0846 9.99935H17.5846ZM10.0013 17.5827C5.81314 17.5827 2.41797 14.1875 2.41797 9.99935H0.917969C0.917969 15.0159 4.98472 19.0827 10.0013 19.0827V17.5827ZM2.41797 9.99935C2.41797 5.81119 5.81314 2.41602 10.0013 2.41602V0.916016C4.98472 0.916016 0.917969 4.98276 0.917969 9.99935H2.41797ZM10.0013 2.41602C14.1895 2.41602 17.5846 5.81119 17.5846 9.99935H19.0846C19.0846 4.98276 15.0179 0.916016 10.0013 0.916016V2.41602ZM10.918 7.49935C10.918 7.68295 10.8648 7.85185 10.7732 7.99417L12.0346 8.80585C12.2773 8.42873 12.418 7.97933 12.418 7.49935H10.918ZM9.08464 7.49935C9.08464 6.99309 9.49504 6.58268 10.0013 6.58268V5.08268C8.66661 5.08268 7.58464 6.16466 7.58464 7.49935H9.08464ZM10.0013 6.58268C10.5076 6.58268 10.918 6.99309 10.918 7.49935H12.418C12.418 6.16466 11.336 5.08268 10.0013 5.08268V6.58268ZM9.2513 10.8327V11.2493H10.7513V10.8327H9.2513ZM10.7732 7.99417C10.6722 8.15116 10.5445 8.31539 10.3903 8.50706C10.2439 8.68898 10.0674 8.90292 9.90936 9.12018C9.59849 9.54743 9.2513 10.1255 9.2513 10.8327H10.7513C10.7513 10.6194 10.8564 10.3682 11.1223 10.0027C11.2526 9.82361 11.3956 9.65036 11.5589 9.4474C11.7144 9.2542 11.8866 9.03589 12.0346 8.80585L10.7732 7.99417ZM9.2513 13.3327V14.166H10.7513V13.3327H9.2513Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2716_19325">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
export function ViewIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="14"
      viewBox="0 0 17 14"
      fill="none"
    >
      <path
        d="M8.3198 0.504883C10.0075 0.504883 11.6075 1.0904 13.0007 2.1744C14.3938 3.25048 15.5799 4.82504 16.4317 6.79523C16.4954 6.94556 16.4954 7.11964 16.4317 7.26206C14.7281 11.2024 11.6951 13.5603 8.3198 13.5603H8.31184C4.9445 13.5603 1.91149 11.2024 0.20792 7.26206C0.144235 7.11964 0.144235 6.94556 0.20792 6.79523C1.91149 2.85486 4.9445 0.504883 8.31184 0.504883H8.3198ZM8.3198 3.86765C6.5605 3.86765 5.13555 5.28396 5.13555 7.0326C5.13555 8.77332 6.5605 10.1896 8.3198 10.1896C10.0711 10.1896 11.4961 8.77332 11.4961 7.0326C11.4961 5.28396 10.0711 3.86765 8.3198 3.86765ZM8.32076 5.05276C9.41136 5.05276 10.303 5.93895 10.303 7.03086C10.303 8.11486 9.41136 9.00104 8.32076 9.00104C7.22219 9.00104 6.3306 8.11486 6.3306 7.03086C6.3306 6.89635 6.34652 6.76975 6.3704 6.64315H6.41021C7.29384 6.64315 8.01029 5.94686 8.04214 5.0765C8.1297 5.06068 8.22523 5.05276 8.32076 5.05276Z"
        fill="#45464E"
      />
    </svg>
  );
}
export function AreaLocationIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 6.22222C15 9.65866 11.25 14 9 14C6.75 14 3 9.65866 3 6.22222C3 2.78578 5.68629 0 9 0C12.3137 0 15 2.78578 15 6.22222ZM11 6C11 7.10457 10.1046 8 9 8C7.89543 8 7 7.10457 7 6C7 4.89543 7.89543 4 9 4C10.1046 4 11 4.89543 11 6ZM2.83346 13H4.17034C5.73742 14.7664 7.58978 16 9.00013 16C10.4105 16 12.2628 14.7664 13.8299 13H15.1668C15.9742 13 16.7024 13.4855 17.0129 14.2308L17.8463 16.2308C18.3952 17.5481 17.4273 19 16.0001 19H2.00013C0.572969 19 -0.394934 17.5481 0.153972 16.2308L0.987306 14.2308C1.29784 13.4855 2.02606 13 2.83346 13Z"
        fill="#BDC167"
      />
    </svg>
  );
}

export function AvatarImg({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="31"
      viewBox="0 0 30 31"
      fill="none"
    >
      <path
        opacity="0.4"
        d="M21.32 30.0827H8.68115C3.73844 30.0827 0.417969 26.6161 0.417969 21.4556V9.54457C0.417969 4.3841 3.73844 0.916016 8.68115 0.916016H21.3215C26.2642 0.916016 29.5846 4.3841 29.5846 9.54457V21.4556C29.5846 26.6161 26.2642 30.0827 21.32 30.0827"
        fill="#252A4D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8997 10.6508C13.8997 12.6487 12.2737 14.2748 10.2758 14.2748C8.27642 14.2748 6.65183 12.6487 6.65183 10.6508C6.65183 8.65289 8.27642 7.02539 10.2758 7.02539C12.2737 7.02539 13.8997 8.65289 13.8997 10.6508ZM25.793 18.5442C26.1328 18.8738 26.3764 19.25 26.5368 19.6511C27.0224 20.8644 26.7701 22.3227 26.251 23.5244C25.6355 24.955 24.4572 26.0356 22.9726 26.5081C22.3135 26.7196 21.6222 26.81 20.9324 26.81H8.71012C7.49387 26.81 6.41762 26.5271 5.53533 25.9963C4.98262 25.6638 4.88492 24.8981 5.29471 24.3994C5.98012 23.5681 6.65679 22.734 7.33929 21.8925C8.64012 20.2825 9.51658 19.8158 10.4907 20.2256C10.886 20.3948 11.2826 20.65 11.691 20.9183C12.7789 21.6388 14.2912 22.6275 16.2832 21.5542C17.6449 20.8096 18.4354 19.5355 19.1233 18.4265L19.1372 18.4042C19.1835 18.33 19.2294 18.2558 19.2752 18.1818C19.5091 17.8038 19.7395 17.4315 20.0005 17.0888C20.3243 16.6644 21.526 15.3373 23.0791 16.2823C24.0693 16.8773 24.902 17.6823 25.793 18.5442Z"
        fill="#252A4D"
      />
    </svg>
  );
}
export function ReassignIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        opacity="0.4"
        d="M9 2C6.38 2 4.25 4.13 4.25 6.75C4.25 9.32 6.26 11.4 8.88 11.49C8.96 11.48 9.04 11.48 9.1 11.49C9.12 11.49 9.13 11.49 9.15 11.49C9.16 11.49 9.16 11.49 9.17 11.49C11.73 11.4 13.74 9.32 13.75 6.75C13.75 4.13 11.62 2 9 2Z"
        fill="#BDC167"
      />
      <path
        d="M14.0809 14.15C11.2909 12.29 6.74094 12.29 3.93094 14.15C2.66094 15 1.96094 16.15 1.96094 17.38C1.96094 18.61 2.66094 19.75 3.92094 20.59C5.32094 21.53 7.16094 22 9.00094 22C10.8409 22 12.6809 21.53 14.0809 20.59C15.3409 19.74 16.0409 18.6 16.0409 17.36C16.0309 16.13 15.3409 14.99 14.0809 14.15Z"
        fill="#BDC167"
      />
      <path
        opacity="0.4"
        d="M19.9894 7.34001C20.1494 9.28001 18.7694 10.98 16.8594 11.21C16.8494 11.21 16.8494 11.21 16.8394 11.21H16.8094C16.7494 11.21 16.6894 11.21 16.6394 11.23C15.6694 11.28 14.7794 10.97 14.1094 10.4C15.1394 9.48001 15.7294 8.10001 15.6094 6.60001C15.5394 5.79001 15.2594 5.05001 14.8394 4.42001C15.2194 4.23001 15.6594 4.11001 16.1094 4.07001C18.0694 3.90001 19.8194 5.36001 19.9894 7.34001Z"
        fill="#2F355B"
      />
      <path
        d="M21.9902 16.59C21.9102 17.56 21.2902 18.4 20.2502 18.97C19.2502 19.52 17.9902 19.78 16.7402 19.75C17.4602 19.1 17.8802 18.29 17.9602 17.43C18.0602 16.19 17.4702 15 16.2902 14.05C15.6202 13.52 14.8402 13.1 13.9902 12.79C16.2002 12.15 18.9802 12.58 20.6902 13.96C21.6102 14.7 22.0802 15.63 21.9902 16.59Z"
        fill="#2F355B"
      />
    </svg>
  );
}
export function DocumentViewIcon({ size, color, title, children }) {
  return (
    <svg
      width="39"
      height="39"
      viewBox="0 0 39 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.398438 6.85056C0.398438 3.39071 3.2032 0.585938 6.66305 0.585938H32.5046C35.9644 0.585938 38.7692 3.3907 38.7692 6.85055V32.6921C38.7692 36.1519 35.9644 38.9567 32.5046 38.9567H6.66306C3.20321 38.9567 0.398438 36.1519 0.398438 32.6921V6.85056Z"
        fill="#059646"
        fill-opacity="0.08"
      />
      <path
        d="M20.4383 17.8136H24.7452L20.4383 13.5066V17.8136ZM14.9568 12.332H21.2214L25.9199 17.0305V26.4274C25.9199 26.8428 25.7548 27.2411 25.4611 27.5349C25.1674 27.8286 24.7691 27.9936 24.3537 27.9936H14.9568C14.0876 27.9936 13.3906 27.2888 13.3906 26.4274V13.8982C13.3906 13.029 14.0876 12.332 14.9568 12.332ZM22.0045 24.8613V23.2951H14.9568V24.8613H22.0045ZM24.3537 21.729V20.1628H14.9568V21.729H24.3537Z"
        fill="#059646"
      />
    </svg>
  );
}

export function NotificationBellIcon({ size, color, title, children }) {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="21" cy="21" r="21" fill="#D8C212" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4972 12.6874C16.8767 12.5214 17.0498 12.0792 16.8838 11.6997C16.7179 11.3202 16.2757 11.1471 15.8962 11.313C13.6394 12.2999 11.7245 13.9204 10.3755 15.9493C10.1462 16.2943 10.2399 16.7598 10.5848 16.9891C10.9298 17.2185 11.3953 17.1248 11.6246 16.7799C12.8159 14.9882 14.5068 13.5577 16.4972 12.6874ZM26.104 11.313C25.7245 11.1471 25.2823 11.3202 25.1163 11.6997C24.9504 12.0792 25.1235 12.5214 25.503 12.6874C27.4934 13.5577 29.1843 14.9882 30.3755 16.7799C30.6049 17.1248 31.0704 17.2185 31.4153 16.9891C31.7603 16.7598 31.854 16.2943 31.6246 15.9493C30.2756 13.9204 28.3607 12.2999 26.104 11.313ZM27.9916 27.6681C29.2475 26.1207 30.0001 24.1484 30.0001 22.0002C30.0001 17.0297 25.9707 13.0002 21.0001 13.0002C16.0296 13.0002 12.0001 17.0297 12.0001 22.0002C12.0001 24.1484 12.7527 26.1207 14.0086 27.668L12.3459 30.6333C12.1434 30.9946 12.272 31.4518 12.6333 31.6543C12.9946 31.8569 13.4518 31.7282 13.6543 31.3669L15.0969 28.794C16.6772 30.1682 18.7415 31.0002 21.0001 31.0002C23.2587 31.0002 25.323 30.1682 26.9033 28.794L28.346 31.3669C28.5485 31.7282 29.0056 31.8569 29.3669 31.6543C29.7282 31.4517 29.8569 30.9946 29.6543 30.6333L27.9916 27.6681ZM21.0001 16.2502C21.4143 16.2502 21.7501 16.586 21.7501 17.0002V21.5989L24.4161 23.3762C24.7608 23.606 24.8539 24.0716 24.6242 24.4163C24.3944 24.7609 23.9287 24.854 23.5841 24.6243L20.5841 22.6243C20.3754 22.4852 20.2501 22.251 20.2501 22.0002V17.0002C20.2501 16.586 20.5859 16.2502 21.0001 16.2502Z"
        fill="white"
      />
    </svg>
  );
}

export function HandWave({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M15.4467 5.43831C16.3587 7.44906 17.4785 9.91731 18.3185 10.8983C18.4827 10.5166 18.4647 9.87831 18.6522 8.31981C18.8217 6.91206 19.9827 6.77856 20.4807 6.87831C21.5817 7.10781 21.9177 8.22456 21.881 8.63631C21.8225 9.29256 21.8195 9.27006 21.6995 10.8563C21.5232 13.1768 22.4195 14.9288 22.502 16.9156C22.502 20.6596 19.2207 22.4993 16.9242 22.4993C15.0867 22.4993 13.2485 21.3233 12.5592 20.7353L9.11299 17.5891C8.69149 17.2613 7.64899 16.1791 7.19149 15.5566C5.94424 13.8593 7.74799 12.6908 8.76199 12.9841C8.68174 12.9226 8.20099 12.1418 7.97074 11.7593C7.35199 10.5166 7.97073 9.68931 8.42823 9.46206C9.46473 8.94681 10.2267 9.52656 10.4667 9.84306C10.3752 9.68706 10.0872 9.05556 9.62299 7.89756C9.15874 6.74031 9.90649 6.02481 10.3377 5.81181C11.2752 5.37831 12.1662 5.92881 12.389 6.42156C12.4977 6.66156 13.0865 7.95006 13.3415 8.51856C13.1487 8.04756 12.7992 7.11156 12.6755 6.67881C12.4295 5.65881 13.0212 4.96056 13.3962 4.78056C13.9182 4.53081 15.0057 4.46556 15.4362 5.41356L15.4467 5.43831Z"
        fill="#FFC83D"
      />
      <path
        d="M13.3373 5.18717C13.4168 4.93217 13.5255 4.77767 13.608 4.70117C13.53 4.72367 13.458 4.75217 13.395 4.78217C13.02 4.96217 12.4283 5.66117 12.675 6.68042C12.798 7.11317 13.1475 8.04917 13.341 8.52017L13.248 8.31467C13.671 9.28592 14.1983 10.3322 14.5958 11.0072C14.6462 11.0929 14.7286 11.1551 14.8249 11.1801C14.9212 11.205 15.0234 11.1907 15.1092 11.1403C15.1949 11.0899 15.2571 11.0075 15.282 10.9112C15.307 10.8149 15.2927 10.7127 15.2423 10.6269C14.5973 9.53117 13.6163 7.45067 13.335 6.41792C13.2205 6.01581 13.2213 5.58886 13.3373 5.18717ZM7.96953 11.7609C8.14353 12.0504 8.46078 12.5672 8.64003 12.8282C8.87703 13.1132 9.13653 13.3869 9.39903 13.6472C9.69903 13.9434 10.0103 14.2299 10.305 14.5014L10.3298 14.5239C10.6343 14.8044 10.9185 15.0677 11.1653 15.3174C11.1999 15.3525 11.2411 15.3804 11.2865 15.3995C11.3319 15.4187 11.3806 15.4287 11.4299 15.429C11.4792 15.4293 11.528 15.4199 11.5737 15.4014C11.6193 15.3828 11.6608 15.3554 11.6959 15.3208C11.731 15.2862 11.7589 15.245 11.778 15.1996C11.7972 15.1542 11.8072 15.1055 11.8075 15.0562C11.8078 15.0069 11.7984 14.9581 11.7798 14.9124C11.7613 14.8668 11.7339 14.8252 11.6993 14.7902C11.4375 14.5254 11.1398 14.2502 10.8375 13.9727L10.8165 13.9532C10.5195 13.6794 10.2165 13.4004 9.92702 13.1132C9.32852 12.5207 8.81703 11.9252 8.54553 11.3244C8.35278 10.8999 8.30553 10.4027 8.35803 9.99167C8.37644 9.82234 8.42097 9.65688 8.49003 9.50117C8.50466 9.46989 8.52171 9.4398 8.54103 9.41117C8.50353 9.42692 8.46528 9.44492 8.42628 9.46367C7.96953 9.69092 7.35078 10.5182 7.96953 11.7609ZM10.413 5.78042C10.3328 5.83442 10.2233 5.96492 10.1535 6.21842C10.0748 6.50417 10.0635 6.90617 10.1948 7.39067C10.3853 8.09267 10.8638 9.03467 11.4105 9.95717C11.8839 10.7513 12.3929 11.5236 12.936 12.2717C12.9666 12.3113 12.9889 12.3567 13.0017 12.4051C13.0144 12.4535 13.0174 12.5039 13.0103 12.5535C13.0033 12.603 12.9864 12.6507 12.9606 12.6936C12.9349 12.7365 12.9008 12.7738 12.8604 12.8034C12.82 12.8329 12.7741 12.8541 12.7253 12.8656C12.6766 12.8771 12.6261 12.8787 12.5768 12.8704C12.5274 12.8621 12.4802 12.844 12.438 12.8172C12.3957 12.7903 12.3593 12.7553 12.3308 12.7142C11.7735 11.9467 11.2512 11.1544 10.7655 10.3397C10.6155 10.0877 10.4685 9.82967 10.329 9.57167C10.0794 9.02012 9.84361 8.46245 9.62178 7.89917C9.15753 6.74192 9.90528 6.02642 10.3365 5.81417C10.362 5.80142 10.3875 5.79092 10.413 5.78042ZM18.5078 9.70892C18.453 10.3044 18.4215 10.6449 18.324 10.8834C18.318 10.9584 18.3128 11.0259 18.3068 11.0882C18.2978 11.1872 18.3286 11.2858 18.3923 11.3622C18.456 11.4385 18.5475 11.4865 18.6465 11.4954C18.7456 11.5044 18.8441 11.4736 18.9205 11.4099C18.9969 11.3462 19.0448 11.2547 19.0538 11.1557C19.065 11.0334 19.0763 10.8909 19.0875 10.7304C19.1318 10.1357 19.194 9.28742 19.3778 8.22092C19.4543 7.77842 19.653 7.39442 19.8803 7.14392C20.0565 6.95117 20.208 6.87692 20.3123 6.85817C19.7595 6.81917 18.8033 7.05392 18.651 8.32067C18.5963 8.78242 18.5485 9.24497 18.5078 9.70817"
        fill="#D67D00"
      />
      <path
        d="M18.0283 5.6678C18.0287 5.71705 18.0387 5.76575 18.0579 5.81111C18.077 5.85648 18.1049 5.89762 18.14 5.9322C18.1751 5.96678 18.2166 5.99411 18.2622 6.01264C18.3079 6.03117 18.3567 6.04052 18.4059 6.04018C18.4552 6.03983 18.5039 6.02979 18.5493 6.01063C18.5946 5.99147 18.6358 5.96355 18.6703 5.92849C18.7049 5.89342 18.7323 5.85189 18.7508 5.80626C18.7693 5.76063 18.7787 5.7118 18.7783 5.66255C18.7671 3.9413 17.4583 1.54655 14.6458 1.56455C14.5464 1.56525 14.4513 1.60543 14.3814 1.67625C14.3116 1.74706 14.2728 1.84272 14.2734 1.94218C14.2741 2.04164 14.3143 2.13674 14.3851 2.20658C14.456 2.27641 14.5516 2.31525 14.6511 2.31455C16.9251 2.29955 18.0186 4.22555 18.0283 5.6678Z"
        fill="#5092FF"
      />
      <path
        d="M17.1597 7.48957C17.0604 7.49017 16.9649 7.45134 16.8941 7.3816C16.8234 7.31186 16.7832 7.2169 16.7825 7.11757C16.778 6.43507 16.4967 5.52757 15.8997 4.79632C15.3117 4.07632 14.4245 3.53482 13.1847 3.54307C13.0852 3.54377 12.9896 3.50493 12.9188 3.4351C12.848 3.36526 12.8078 3.27016 12.8071 3.1707C12.8064 3.07124 12.8452 2.97558 12.9151 2.90477C12.9849 2.83395 13.08 2.79377 13.1795 2.79307C14.6705 2.78332 15.7655 3.44707 16.4802 4.32157C17.1852 5.18482 17.5265 6.25882 17.5325 7.11232C17.5327 7.16157 17.5233 7.21039 17.5048 7.256C17.4862 7.30161 17.4588 7.34312 17.4242 7.37815C17.3896 7.41318 17.3484 7.44105 17.303 7.46017C17.2577 7.47929 17.2089 7.48928 17.1597 7.48957ZM3.6582 13.2076C3.6582 13.1081 3.61869 13.0127 3.54837 12.9424C3.47804 12.8721 3.38266 12.8326 3.2832 12.8326C3.18375 12.8326 3.08836 12.8721 3.01804 12.9424C2.94771 13.0127 2.9082 13.1081 2.9082 13.2076C2.9082 14.0603 3.24195 15.1366 3.9417 16.0051C4.6512 16.8841 5.7417 17.5546 7.2327 17.5546C7.33216 17.5546 7.42754 17.5151 7.49787 17.4447C7.56819 17.3744 7.6077 17.279 7.6077 17.1796C7.6077 17.0801 7.56819 16.9847 7.49787 16.9144C7.42754 16.8441 7.33216 16.8046 7.2327 16.8046C5.99295 16.8046 5.1087 16.2571 4.5252 15.5341C3.93345 14.7991 3.6582 13.8886 3.6582 13.2068"
        fill="#5092FF"
      />
      <path
        d="M2.40039 14.6484C2.40039 14.549 2.36088 14.4536 2.29056 14.3833C2.22023 14.3129 2.12485 14.2734 2.02539 14.2734C1.92593 14.2734 1.83055 14.3129 1.76023 14.3833C1.6899 14.4536 1.65039 14.549 1.65039 14.6484C1.65039 16.3697 2.94264 18.7734 5.75514 18.7734C5.8546 18.7734 5.94998 18.7339 6.02031 18.6636C6.09063 18.5933 6.13014 18.4979 6.13014 18.3984C6.13014 18.299 6.09063 18.2036 6.02031 18.1333C5.94998 18.0629 5.8546 18.0234 5.75514 18.0234C3.48114 18.0234 2.40039 16.0914 2.40039 14.6484Z"
        fill="#5092FF"
      />
    </svg>
  );
}

export function RefundRequestIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="43"
      height="43"
      viewBox="0 0 43 43"
      fill="none"
    >
      <rect
        x="0.658203"
        y="0.847656"
        width="41.7827"
        height="41.7827"
        rx="20.8914"
        fill="#BDC167"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.157 12.6777C23.0844 12.6777 25.6078 14.4069 26.7617 16.8995C25.7429 17.4925 25.058 18.5963 25.058 19.8601C25.058 21.151 25.7725 22.2749 26.8275 22.8581C25.7871 25.243 23.5051 26.9619 20.7983 27.1983C20.7987 27.2075 20.7989 27.2168 20.7989 27.2262V29.1297C24.9261 28.8452 28.3045 25.8387 29.1518 21.8924C28.9408 21.962 28.7154 21.9996 28.4811 21.9996C27.2995 21.9996 26.3417 21.0417 26.3417 19.8601C26.3417 18.6785 27.2995 17.7207 28.4811 17.7207C29.6387 17.7207 30.5816 18.64 30.6194 19.7884C30.6332 19.8406 30.6405 19.8954 30.6405 19.952C30.6405 25.7418 25.9469 30.4354 20.157 30.4354C19.8026 30.4354 19.5152 30.148 19.5152 29.7936V27.2262C19.5152 27.2168 19.5154 27.2075 19.5158 27.1983C15.7987 26.8736 12.8828 23.7533 12.8828 19.952C12.8828 15.9345 16.1396 12.6777 20.157 12.6777ZM20.157 18.6683C20.866 18.6683 21.4407 19.243 21.4407 19.952C21.4407 20.6609 20.866 21.2356 20.157 21.2356C19.4481 21.2356 18.8733 20.6609 18.8733 19.952C18.8733 19.243 19.4481 18.6683 20.157 18.6683Z"
        fill="white"
      />
    </svg>
  );
}
export function NewOrderIcon({ size, color, title, children }) {
  return (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        class="ripple-background"
        cx="15.877"
        cy="15.5"
        r="15.0059"
        fill="#00B207"
        fill-opacity="0.1"
      />
      <circle
        class="ripple"
        cx="15.877"
        cy="15.5"
        r="15.0059"
        fill="#00B207"
        fill-opacity="0.1"
      />
      <g clip-path="url(#clip0_1310_14238)">
        <path
          d="M14.0078 17.5645L14.0078 20.2078"
          stroke="#00B207"
          strokeWidth="0.991251"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.9727 17.5645L17.9727 20.2078"
          stroke="#00B207"
          strokeWidth="0.991251"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.0234 12.2781V10.9564C12.0234 10.2265 12.6152 9.63477 13.3451 9.63477H18.6318C19.3617 9.63477 19.9534 10.2265 19.9534 10.9564V12.2781"
          stroke="#00B207"
          strokeWidth="0.991251"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.7667 14.9207H22.2078M19.9755 12.2773L11.999 12.2773C10.3398 12.2773 9.09867 13.8146 9.43384 15.4546L10.5142 20.7413C10.7652 21.9695 11.8368 22.8507 13.0794 22.8507H18.8951C20.1377 22.8507 21.2092 21.9695 21.4603 20.7413L22.5407 15.4546C22.8758 13.8146 21.6347 12.2773 19.9755 12.2773Z"
          stroke="#00B207"
          strokeWidth="0.991251"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1310_14238">
          <rect
            width="15.86"
            height="15.86"
            fill="white"
            transform="translate(8.05859 8.3125)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export function ArrowRightIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
    >
      <path
        d="M5.3125 3.96094L9.6875 8.33594L5.3125 12.7109"
        stroke="#53545C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function AppUsageIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="24"
      viewBox="0 0 23 24"
      fill="none"
    >
      <path
        d="M11.8931 20.2492C16.4833 20.2492 20.2043 16.5282 20.2043 11.9381C20.2043 7.34793 16.4833 3.62695 11.8931 3.62695C7.30301 3.62695 3.58203 7.34793 3.58203 11.9381C3.58203 16.5282 7.30301 20.2492 11.8931 20.2492Z"
        fill="white"
        fill-opacity="0.01"
      />
      <path
        d="M11.8931 15.2625V11.9381M11.8931 8.61362H11.9015M20.2043 11.9381C20.2043 16.5282 16.4833 20.2492 11.8931 20.2492C7.30301 20.2492 3.58203 16.5282 3.58203 11.9381C3.58203 7.34793 7.30301 3.62695 11.8931 3.62695C16.4833 3.62695 20.2043 7.34793 20.2043 11.9381Z"
        stroke="#6C737F"
        strokeWidth="1.84691"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function AlarmClockIcon() {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="shake-animation"
    >
      <circle cx="21" cy="21" r="21" fill="#D8C212" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4972 12.6874C16.8767 12.5214 17.0498 12.0792 16.8838 11.6997C16.7179 11.3202 16.2757 11.1471 15.8962 11.313C13.6394 12.2999 11.7245 13.9204 10.3755 15.9493C10.1462 16.2943 10.2399 16.7598 10.5848 16.9891C10.9298 17.2185 11.3953 17.1248 11.6246 16.7799C12.8159 14.9882 14.5068 13.5577 16.4972 12.6874ZM26.104 11.313C25.7245 11.1471 25.2823 11.3202 25.1163 11.6997C24.9504 12.0792 25.1235 12.5214 25.503 12.6874C27.4934 13.5577 29.1843 14.9882 30.3755 16.7799C30.6049 17.1248 31.0704 17.2185 31.4153 16.9891C31.7603 16.7598 31.854 16.2943 31.6246 15.9493C30.2756 13.9204 28.3607 12.2999 26.104 11.313ZM27.9916 27.6681C29.2475 26.1207 30.0001 24.1484 30.0001 22.0002C30.0001 17.0297 25.9707 13.0002 21.0001 13.0002C16.0296 13.0002 12.0001 17.0297 12.0001 22.0002C12.0001 24.1484 12.7527 26.1207 14.0086 27.668L12.3459 30.6333C12.1434 30.9946 12.272 31.4518 12.6333 31.6543C12.9946 31.8569 13.4518 31.7282 13.6543 31.3669L15.0969 28.794C16.6772 30.1682 18.7415 31.0002 21.0001 31.0002C23.2587 31.0002 25.323 30.1682 26.9033 28.794L28.346 31.3669C28.5485 31.7282 29.0056 31.8569 29.3669 31.6543C29.7282 31.4517 29.8569 30.9946 29.6543 30.6333L27.9916 27.6681ZM21.0001 16.2502C21.4143 16.2502 21.7501 16.586 21.7501 17.0002V21.5989L24.4161 23.3762C24.7608 23.606 24.8539 24.0716 24.6242 24.4163C24.3944 24.7609 23.9287 24.854 23.5841 24.6243L20.5841 22.6243C20.3754 22.4852 20.2501 22.251 20.2501 22.0002V17.0002C20.2501 16.586 20.5859 16.2502 21.0001 16.2502Z"
        fill="white"
      />
    </svg>
  );
}

export function ViewStaffIcon({ size, color, title, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M2.41999 13.0479C2.28385 12.8323 2.21578 12.7245 2.17769 12.5583C2.1491 12.4334 2.1491 12.2365 2.17769 12.1117C2.21578 11.9454 2.28385 11.8377 2.41999 11.6221C3.54492 9.84081 6.89343 5.33789 11.9963 5.33789C17.0992 5.33789 20.4477 9.84081 21.5726 11.6221C21.7088 11.8377 21.7768 11.9454 21.8149 12.1117C21.8435 12.2365 21.8435 12.4334 21.8149 12.5583C21.7768 12.7245 21.7088 12.8323 21.5726 13.0479C20.4477 14.8291 17.0992 19.3321 11.9963 19.3321C6.89343 19.3321 3.54492 14.8291 2.41999 13.0479Z"
        fill="white"
        fill-opacity="0.01"
      />
      <path
        d="M11.9952 15.3342C13.6517 15.3342 14.9944 13.9915 14.9944 12.3351C14.9944 10.6787 13.6517 9.33594 11.9952 9.33594C10.3388 9.33594 8.99609 10.6787 8.99609 12.3351C8.99609 13.9915 10.3388 15.3342 11.9952 15.3342Z"
        fill="white"
        fill-opacity="0.01"
      />
      <path
        d="M2.41999 13.0479C2.28385 12.8323 2.21578 12.7245 2.17769 12.5583C2.1491 12.4334 2.1491 12.2365 2.17769 12.1117C2.21578 11.9454 2.28385 11.8377 2.41999 11.6221C3.54492 9.84081 6.89343 5.33789 11.9963 5.33789C17.0992 5.33789 20.4477 9.84081 21.5726 11.6221C21.7088 11.8377 21.7768 11.9454 21.8149 12.1117C21.8435 12.2365 21.8435 12.4334 21.8149 12.5583C21.7768 12.7245 21.7088 12.8323 21.5726 13.0479C20.4477 14.8291 17.0992 19.3321 11.9963 19.3321C6.89343 19.3321 3.54492 14.8291 2.41999 13.0479Z"
        stroke="#6C737F"
        strokeWidth="1.99943"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9952 15.3342C13.6517 15.3342 14.9944 13.9915 14.9944 12.3351C14.9944 10.6787 13.6517 9.33594 11.9952 9.33594C10.3388 9.33594 8.99609 10.6787 8.99609 12.3351C8.99609 13.9915 10.3388 15.3342 11.9952 15.3342Z"
        stroke="#6C737F"
        strokeWidth="1.99943"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SearchIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
    >
      <circle
        cx="4.24632"
        cy="4.17796"
        r="3.53089"
        stroke="#252A4D"
        strokeWidth="1.14959"
      />
      <line
        x1="8.35899"
        y1="9.10547"
        x2="6.70846"
        y2="7.45494"
        stroke="#252A4D"
        strokeWidth="1.14959"
        strokeLinecap="round"
      />
    </svg>
  );
}
export function ViewPersonIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M8.50521 9.27799C6.39187 9.27799 4.67188 7.55799 4.67188 5.44466C4.67188 3.33133 6.39187 1.61133 8.50521 1.61133C10.6185 1.61133 12.3385 3.33133 12.3385 5.44466C12.3385 7.55799 10.6185 9.27799 8.50521 9.27799ZM8.50521 2.61133C6.94521 2.61133 5.67187 3.88466 5.67187 5.44466C5.67187 7.00466 6.94521 8.27799 8.50521 8.27799C10.0652 8.27799 11.3385 7.00466 11.3385 5.44466C11.3385 3.88466 10.0652 2.61133 8.50521 2.61133Z"
        fill="#919191"
      />
      <path
        d="M14.2307 15.944C13.9573 15.944 13.7307 15.7173 13.7307 15.444C13.7307 13.144 11.384 11.2773 8.50401 11.2773C5.62401 11.2773 3.27734 13.144 3.27734 15.444C3.27734 15.7173 3.05068 15.944 2.77734 15.944C2.50401 15.944 2.27734 15.7173 2.27734 15.444C2.27734 12.5973 5.07067 10.2773 8.50401 10.2773C11.9373 10.2773 14.7307 12.5973 14.7307 15.444C14.7307 15.7173 14.504 15.944 14.2307 15.944Z"
        fill="#919191"
      />
    </svg>
  );
}
export function QuerySearchIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M6.00391 9.27734C6.41812 9.27734 6.75391 8.94156 6.75391 8.52734C6.75391 8.11313 6.41812 7.77734 6.00391 7.77734C5.58969 7.77734 5.25391 8.11313 5.25391 8.52734C5.25391 8.94156 5.58969 9.27734 6.00391 9.27734Z"
        fill="#919191"
      />
      <path
        d="M6.50391 6.77734H5.50391V4.77734H6.50391C6.76912 4.77734 7.02348 4.67199 7.21101 4.48445C7.39855 4.29691 7.50391 4.04256 7.50391 3.77734C7.50391 3.51213 7.39855 3.25777 7.21101 3.07024C7.02348 2.8827 6.76912 2.77734 6.50391 2.77734H5.50391C5.23877 2.77761 4.98457 2.88305 4.79709 3.07053C4.60961 3.25801 4.50417 3.51221 4.50391 3.77734V4.02734H3.50391V3.77734C3.50457 3.24711 3.71549 2.73879 4.09042 2.36386C4.46535 1.98893 4.97368 1.77801 5.50391 1.77734H6.50391C7.03434 1.77734 7.54305 1.98806 7.91812 2.36313C8.29319 2.7382 8.50391 3.24691 8.50391 3.77734C8.50391 4.30778 8.29319 4.81648 7.91812 5.19156C7.54305 5.56663 7.03434 5.77734 6.50391 5.77734V6.77734Z"
        fill="#919191"
      />
      <path
        d="M11.7279 11.2934C12.2281 10.6949 12.5949 9.99649 12.8038 9.24492C13.0127 8.49334 13.0589 7.70586 12.9393 6.93501C12.8198 6.16417 12.5372 5.42769 12.1104 4.77473C11.6836 4.12176 11.1225 3.56734 10.4644 3.14844L9.96491 4.01344C10.6169 4.43993 11.147 5.02844 11.5032 5.72135C11.8594 6.41426 12.0296 7.18781 11.997 7.96624C11.9644 8.74467 11.7302 9.50129 11.3173 10.162C10.9044 10.8227 10.327 11.3649 9.64165 11.7354C8.95628 12.1059 8.18642 12.292 7.40749 12.2756C6.62855 12.2591 5.86724 12.0407 5.1981 11.6416C4.52897 11.2425 3.97496 10.6765 3.59032 9.99892C3.20569 9.32138 3.00362 8.55555 3.00391 7.77644H2.00391C2.00315 8.82166 2.30046 9.84543 2.86097 10.7277C3.42147 11.6099 4.22193 12.314 5.16845 12.7574C6.11497 13.2008 7.1683 13.3651 8.20489 13.231C9.24148 13.0969 10.2183 12.6701 11.0209 12.0004L14.7969 15.7764L15.5039 15.0694L11.7279 11.2934Z"
        fill="#919191"
      />
    </svg>
  );
}

export function AvatarDefaultIcon() {
  return (
    <svg
      width="43"
      height="43"
      viewBox="0 0 43 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2966_17397)">
        <rect
          y="0.0727539"
          width="42.9272"
          height="42.9272"
          rx="21.4636"
          fill="#252A4D"
          fill-opacity="0.05"
        />
        <path
          d="M30.279 28.2845V30.7656H12.9111V28.2845C12.9111 28.2845 12.9111 23.3223 21.5951 23.3223C30.279 23.3223 30.279 28.2845 30.279 28.2845ZM25.937 16.4992C25.937 15.6404 25.6824 14.801 25.2053 14.0869C24.7282 13.3729 24.0501 12.8164 23.2567 12.4877C22.4633 12.1591 21.5902 12.0731 20.748 12.2407C19.9057 12.4082 19.1321 12.8217 18.5248 13.429C17.9176 14.0362 17.5041 14.8099 17.3365 15.6521C17.169 16.4944 17.255 17.3674 17.5836 18.1608C17.9122 18.9542 18.4688 19.6323 19.1828 20.1094C19.8968 20.5865 20.7363 20.8412 21.5951 20.8412C22.7466 20.8412 23.851 20.3837 24.6653 19.5694C25.4796 18.7551 25.937 17.6508 25.937 16.4992Z"
          fill="#DADEE9"
        />
      </g>
      <rect
        x="0.107318"
        y="0.180072"
        width="42.7126"
        height="42.7126"
        rx="21.3563"
        stroke="white"
        strokeWidth="0.214636"
      />
      <defs>
        <clipPath id="clip0_2966_17397">
          <rect
            y="0.0727539"
            width="42.9272"
            height="42.9272"
            rx="21.4636"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export function ExportIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8.08073 10.291L8.08073 2.26367"
        stroke="#0E2354"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.0273 8.33887L8.08334 10.2909L6.13934 8.33887"
        stroke="#0E2354"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.5061 5H12.2121C13.7521 5 15 6.2121 15 7.70867L15 11.2987C15 12.7908 13.7551 14 12.2189 14L3.78865 14C2.24865 14 1 12.7872 1 11.2913L1 7.70059C1 6.20916 2.24562 5 3.78108 5H4.49395"
        stroke="#0E2354"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

// Admin screen icons
export function NewBiulding({ size, color, title, children }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={color || "none"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 7C9.5 7.55228 9.05229 8 8.5 8H7.5C6.94772 8 6.5 7.55228 6.5 7C6.5 6.44772 6.94772 6 7.5 6H8.5C9.05229 6 9.5 6.44772 9.5 7Z"
        fill="black"
      />
      <path
        d="M12.5 11C13.0523 11 13.5 10.5523 13.5 10C13.5 9.44772 13.0523 9 12.5 9H11.5C10.9477 9 10.5 9.44772 10.5 10C10.5 10.5523 10.9477 11 11.5 11H12.5Z"
        fill="black"
      />
      <path
        d="M9.5 13C9.5 13.5523 9.05229 14 8.5 14H7.5C6.94772 14 6.5 13.5523 6.5 13C6.5 12.4477 6.94772 12 7.5 12H8.5C9.05229 12 9.5 12.4477 9.5 13Z"
        fill={color || "black"}
      />
      <path
        d="M12.5 8C13.0523 8 13.5 7.55228 13.5 7C13.5 6.44772 13.0523 6 12.5 6H11.5C10.9477 6 10.5 6.44772 10.5 7C10.5 7.55228 10.9477 8 11.5 8H12.5Z"
        fill={color || "black"}
      />
      <path
        d="M9.5 10C9.5 10.5523 9.05229 11 8.5 11H7.5C6.94772 11 6.5 10.5523 6.5 10C6.5 9.44772 6.94772 9 7.5 9H8.5C9.05229 9 9.5 9.44772 9.5 10Z"
        fill={color || "black"}
      />
      <path
        d="M12.5 14C13.0523 14 13.5 13.5523 13.5 13C13.5 12.4477 13.0523 12 12.5 12H11.5C10.9477 12 10.5 12.4477 10.5 13C10.5 13.5523 10.9477 14 11.5 14H12.5Z"
        fill={color || "black"}
      />
      <path
        d="M9.5 16C9.5 16.5523 9.05229 17 8.5 17H7.5C6.94772 17 6.5 16.5523 6.5 16C6.5 15.4477 6.94772 15 7.5 15H8.5C9.05229 15 9.5 15.4477 9.5 16Z"
        fill={color || "black"}
      />
      <path
        d="M12.5 17C13.0523 17 13.5 16.5523 13.5 16C13.5 15.4477 13.0523 15 12.5 15H11.5C10.9477 15 10.5 15.4477 10.5 16C10.5 16.5523 10.9477 17 11.5 17H12.5Z"
        fill={color || "black"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 5C4 3.89543 4.89543 3 6 3H14C15.1046 3 16 3.89543 16 5V9H19C20.1046 9 21 9.89543 21 11V19H22C22.5523 19 23 19.4477 23 20C23 20.5523 22.5523 21 22 21H2C1.44772 21 1 20.5523 1 20C1 19.4477 1.44772 19 2 19H4V5ZM6 19H14V5H6V19ZM19 15V14H18.5C17.9477 14 17.5 13.5523 17.5 13C17.5 12.4477 17.9477 12 18.5 12H19V11H16V19H19V17H18.5C17.9477 17 17.5 16.5523 17.5 16C17.5 15.4477 17.9477 15 18.5 15H19Z"
        fill={color || "black"}
      />
    </svg>
  );
}

export function UpandDownIcon({ size, color, title, children }) {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill={color || "none"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.481 10.3279C10.5218 10.3688 10.5542 10.4172 10.5764 10.4706C10.5985 10.524 10.6099 10.5812 10.6099 10.6389C10.6099 10.6967 10.5985 10.753ææ9 10.5764 10.8072C10.5542 10.8606 10.5218 10.9091 10.481 10.9499L7.84365 13.5872C7.80283 13.6281 7.75435 13.6605 7.70099 13.6826C7.64763 13.7047 7.59043 13.7161 7.53267 13.7161C7.4749 13.7161 7.41771 13.7047 7.36435 13.6826C7.31099 13.6605 7.26251 13.6281 7.22169 13.5872L4.58438 10.9499C4.5019 10.8674 4.45557 10.7556 4.45557 10.6389C4.45557 10.5223 4.5019 10.4104 4.58438 10.3279C4.66686 10.2455 4.77872 10.1991 4.89536 10.1991C5.012 10.1991 5.12387 10.2455 5.20634 10.3279L7.53267 12.6548L9.85899 10.3279C9.89982 10.2871 9.94829 10.2547 10.0017 10.2325C10.055 10.2104 10.1122 10.199 10.17 10.199C10.2277 10.199 10.2849 10.2104 10.3383 10.2325C10.3917 10.2547 10.4401 10.2871 10.481 10.3279ZM5.20634 5.6753L7.53267 3.34842L9.85899 5.6753C9.94147 5.75777 10.0533 5.80411 10.17 5.80411C10.2866 5.80411 10.3985 5.75777 10.481 5.6753C10.5634 5.59282 10.6098 5.48095 10.6098 5.36431C10.6098 5.24767 10.5634 5.13581 10.481 5.05333L7.84365 2.41602C7.80283 2.37516 7.75435 2.34274 7.70099 2.32061C7.64763 2.29849 7.59043 2.28711 7.53267 2.28711C7.4749 2.28711 7.41771 2.29849 7.36435 2.32061C7.31099 2.34274 7.26251 2.37516 7.22169 2.41602L4.58438 5.05333C4.5019 5.13581 4.45557 5.24767 4.45557 5.36431C4.45557 5.48095 4.5019 5.59282 4.58438 5.6753C4.66686 5.75777 4.77872 5.80411 4.89536 5.80411C5.012 5.80411 5.12387 5.75777 5.20634 5.6753Z"
        fill={color || "#4E4E4D"}
      />
    </svg>
  );
}
export function EyeIcon({ closed }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {closed ? (
        <>
          <path
            d="M9.88 9.88a3 3 0 1 0 4.24 4.24"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="m10.73 5.08-1.39.87A11.75 11.75 0 0 0 2.18 12a11.75 11.75 0 0 0 7.16 6.05l1.39.87"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="m13.27 18.92 1.39-.87A11.75 11.75 0 0 0 21.82 12a11.75 11.75 0 0 0-7.16-6.05l-1.39-.87"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <line
            x1="2"
            y1="2"
            x2="22"
            y2="22"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </>
      ) : (
        <>
          <path
            d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" />
        </>
      )}
    </svg>
  );
}
export function DownloadIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path d="M0.625 12.375C0.79076 12.375 0.949732 12.4408 1.06694 12.5581C1.18415 12.6753 1.25 12.8342 1.25 13V16.125C1.25 16.4565 1.3817 16.7745 1.61612 17.0089C1.85054 17.2433 2.16848 17.375 2.5 17.375H17.5C17.8315 17.375 18.1495 17.2433 18.3839 17.0089C18.6183 16.7745 18.75 16.4565 18.75 16.125V13C18.75 12.8342 18.8158 12.6753 18.9331 12.5581C19.0503 12.4408 19.2092 12.375 19.375 12.375C19.5408 12.375 19.6997 12.4408 19.8169 12.5581C19.9342 12.6753 20 12.8342 20 13V16.125C20 16.788 19.7366 17.4239 19.2678 17.8928C18.7989 18.3616 18.163 18.625 17.5 18.625H2.5C1.83696 18.625 1.20107 18.3616 0.732233 17.8928C0.263392 17.4239 0 16.788 0 16.125V13C0 12.8342 0.065848 12.6753 0.183058 12.5581C0.300269 12.4408 0.45924 12.375 0.625 12.375Z" />
      <path d="M9.55731 14.8175C9.61537 14.8757 9.68434 14.9219 9.76027 14.9534C9.8362 14.9849 9.9176 15.0011 9.99981 15.0011C10.082 15.0011 10.1634 14.9849 10.2394 14.9534C10.3153 14.9219 10.3843 14.8757 10.4423 14.8175L14.1923 11.0675C14.3097 10.9501 14.3756 10.791 14.3756 10.625C14.3756 10.459 14.3097 10.2999 14.1923 10.1825C14.075 10.0651 13.9158 9.99921 13.7498 9.99921C13.5838 9.99921 13.4247 10.0651 13.3073 10.1825L10.6248 12.8663V1.875C10.6248 1.70924 10.559 1.55027 10.4418 1.43306C10.3245 1.31585 10.1656 1.25 9.99981 1.25C9.83405 1.25 9.67508 1.31585 9.55787 1.43306C9.44066 1.55027 9.37481 1.70924 9.37481 1.875V12.8663L6.69231 10.1825C6.57496 10.0651 6.41578 9.99921 6.24981 9.99921C6.08384 9.99921 5.92467 10.0651 5.80731 10.1825C5.68995 10.2999 5.62402 10.459 5.62402 10.625C5.62402 10.791 5.68995 10.9501 5.80731 11.0675L9.55731 14.8175Z" />
    </svg>
  );
}

export const AddIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      fill="none"
      viewBox="0 0 17 16"
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M13.167 7.333h-4v-4a.666.666 0 1 0-1.334 0v4h-4a.666.666 0 1 0 0 1.333h4v4a.666.666 0 1 0 1.334 0v-4h4a.667.667 0 1 0 0-1.333"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};
export const CompanyBuildingIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      fill="none"
      viewBox="0 0 28 28"
    >
      <path
        fill="#D06D01"
        d="M11.083 8.167c0 .644-.522 1.166-1.166 1.166H8.75A1.167 1.167 0 1 1 8.75 7h1.167c.644 0 1.166.522 1.166 1.167M14.583 12.833a1.167 1.167 0 1 0 0-2.333h-1.166a1.167 1.167 0 0 0 0 2.333zM11.083 15.167c0 .644-.522 1.166-1.166 1.166H8.75a1.167 1.167 0 1 1 0-2.333h1.167c.644 0 1.166.522 1.166 1.167M14.583 9.333a1.167 1.167 0 0 0 0-2.333h-1.166a1.167 1.167 0 0 0 0 2.333zM11.083 11.667c0 .644-.522 1.166-1.166 1.166H8.75a1.167 1.167 0 1 1 0-2.333h1.167c.644 0 1.166.522 1.166 1.167M14.583 16.333a1.167 1.167 0 1 0 0-2.333h-1.166a1.167 1.167 0 0 0 0 2.333zM11.083 18.667c0 .644-.522 1.166-1.166 1.166H8.75a1.167 1.167 0 1 1 0-2.333h1.167c.644 0 1.166.522 1.166 1.167M14.583 19.833a1.167 1.167 0 1 0 0-2.333h-1.166a1.167 1.167 0 0 0 0 2.333z"
      ></path>
      <path
        fill="#D06D01"
        fillRule="evenodd"
        d="M4.667 5.833A2.333 2.333 0 0 1 7 3.5h9.333a2.333 2.333 0 0 1 2.334 2.333V10.5h3.5a2.333 2.333 0 0 1 2.333 2.333v9.334h1.167a1.167 1.167 0 1 1 0 2.333H2.333a1.167 1.167 0 1 1 0-2.333h2.334zM7 22.167h9.333V5.833H7zM22.167 17.5v-1.167h-.584a1.167 1.167 0 1 1 0-2.333h.584v-1.167h-3.5v9.334h3.5v-2.334h-.584a1.167 1.167 0 1 1 0-2.333z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};
export const ThreeDIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      fill="none"
      viewBox="0 0 28 28"
    >
      <path
        fill="#D06D01"
        fillRule="evenodd"
        d="M14 2.333c-.556 0-1.105.123-1.608.36L5.013 6.164a4.67 4.67 0 0 0-2.68 4.222v8.28c0 1.163.673 2.223 1.726 2.718l8.333 3.922a3.78 3.78 0 0 0 3.216 0l8.333-3.922a3 3 0 0 0 1.726-2.719v-8.279a4.67 4.67 0 0 0-2.68-4.222l-7.379-3.473A3.8 3.8 0 0 0 14 2.333m9.334 14.446-8.167-4.084V5.064l6.827 3.212a2.33 2.33 0 0 1 1.34 2.111zM14 14.72l9.023 4.511a1 1 0 0 1-.075.042l-8.333 3.922a1.44 1.44 0 0 1-1.23 0l-8.332-3.922a1 1 0 0 1-.076-.042zm-1.166-2.026L4.667 16.78v-6.392c0-.903.522-1.726 1.34-2.11l6.827-3.213z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

export const SuccessBadgeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
    >
      <mask
        id="mask0_389_9784"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="44"
        height="44"
      >
        <path
          d="M24 4L29.253 7.832L35.756 7.82L37.753 14.008L43.021 17.82L41 24L43.021 30.18L37.753 33.992L35.756 40.18L29.253 40.168L24 44L18.747 40.168L12.244 40.18L10.247 33.992L4.979 30.18L7 24L4.979 17.82L10.247 14.008L12.244 7.82L18.747 7.832L24 4Z"
          fill="white"
          stroke="white"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17 24L22 29L32 19"
          stroke="black"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </mask>
      <g mask="url(#mask0_389_9784)">
        <path d="M0 0H48V48H0V0Z" fill="#00A241" />
      </g>
    </svg>
  );
};
export const SuccessBadgeIconLight = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <mask
        id="mask0_1733_16006"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="1"
        y="0"
        width="30"
        height="32"
      >
        <path
          d="M16 2.66663L19.502 5.22129L23.8373 5.21329L25.1687 9.33863L28.6807 11.88L27.3333 16L28.6807 20.12L25.1687 22.6613L23.8373 26.7866L19.502 26.7786L16 29.3333L12.498 26.7786L8.16267 26.7866L6.83134 22.6613L3.31934 20.12L4.66667 16L3.31934 11.88L6.83134 9.33863L8.16267 5.21329L12.498 5.22129L16 2.66663Z"
          fill="white"
          stroke="white"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.333 16L14.6663 19.3333L21.333 12.6666"
          stroke="black"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </mask>
      <g mask="url(#mask0_1733_16006)">
        <path d="M0 0H32V32H0V0Z" fill="#40DD7F" />
      </g>
    </svg>
  );
};
export const CheckmarkIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7478 8.2305H15.75C16.1633 8.2305 16.4993 8.565 16.5 8.97825C16.506 10.9815 15.7313 12.8678 14.3183 14.2882C12.906 15.7087 11.025 16.494 9.02178 16.5H9.00003C7.00428 16.5 5.12703 15.726 3.71178 14.3182C2.29128 12.906 1.50603 11.025 1.50003 9.02175C1.49403 7.01775 2.26878 5.13225 3.68178 3.71175C5.09403 2.29125 6.97503 1.506 8.97828 1.5C9.57453 1.509 10.182 1.569 10.764 1.7085C11.166 1.806 11.4143 2.211 11.3168 2.61375C11.22 3.01575 10.8128 3.26325 10.4123 3.16725C9.94653 3.05475 9.45228 3.0075 8.98278 3C7.38003 3.0045 5.87478 3.633 4.74528 4.76925C3.61503 5.9055 2.99553 7.4145 3.00003 9.01725C3.00453 10.62 3.63303 12.1245 4.76928 13.2547C5.90178 14.3805 7.40328 15 9.00003 15H9.01728C10.62 14.9955 12.1253 14.367 13.2548 13.2307C14.385 12.0937 15.0045 10.5855 15 8.98275C14.9993 8.56875 15.3338 8.23125 15.7478 8.2305ZM6.21978 8.46968C6.51303 8.17643 6.98703 8.17643 7.28028 8.46968L8.96328 10.1527L13.686 4.75568C13.959 4.44593 14.4323 4.41293 14.7443 4.68593C15.0555 4.95818 15.087 5.43218 14.814 5.74418L9.56403 11.7442C9.42753 11.9002 9.23253 11.9924 9.02478 11.9999H9.00003C8.80128 11.9999 8.61078 11.9212 8.46978 11.7802L6.21978 9.53018C5.92653 9.23693 5.92653 8.76293 6.21978 8.46968Z"
        fill="#D64D00"
      />
    </svg>
  );
};

export const SuccessFilledIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 1.25C12.3206 1.25 14.5462 2.17187 16.1872 3.81282C17.8281 5.45376 18.75 7.67936 18.75 10C18.75 12.3206 17.8281 14.5462 16.1872 16.1872C14.5462 17.8281 12.3206 18.75 10 18.75C7.67936 18.75 5.45376 17.8281 3.81282 16.1872C2.17187 14.5462 1.25 12.3206 1.25 10C1.25 7.67936 2.17187 5.45376 3.81282 3.81282C5.45376 2.17187 7.67936 1.25 10 1.25ZM8.91 11.7262L6.96625 9.78125C6.89657 9.71157 6.81384 9.65629 6.7228 9.61858C6.63175 9.58087 6.53417 9.56146 6.43563 9.56146C6.33708 9.56146 6.2395 9.58087 6.14845 9.61858C6.05741 9.65629 5.97468 9.71157 5.905 9.78125C5.76427 9.92198 5.68521 10.1129 5.68521 10.3119C5.68521 10.5109 5.76427 10.7018 5.905 10.8425L8.38 13.3175C8.44948 13.3875 8.53214 13.4431 8.62322 13.4811C8.71429 13.519 8.81197 13.5385 8.91062 13.5385C9.00928 13.5385 9.10696 13.519 9.19803 13.4811C9.28911 13.4431 9.37177 13.3875 9.44125 13.3175L14.5662 8.19125C14.6369 8.12186 14.693 8.03917 14.7315 7.94796C14.77 7.85674 14.7901 7.75881 14.7906 7.65981C14.791 7.5608 14.7719 7.46269 14.7342 7.37112C14.6966 7.27956 14.6412 7.19635 14.5712 7.1263C14.5012 7.05625 14.4181 7.00075 14.3266 6.963C14.2351 6.92524 14.137 6.90598 14.038 6.90632C13.939 6.90667 13.841 6.92661 13.7497 6.965C13.6585 7.00339 13.5757 7.05947 13.5063 7.13L8.91 11.7262Z"
        fill="#06BD4F"
      />
    </svg>
  );
};
export const AlertTriangleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8334 10.8334C10.8334 11.2934 10.4601 11.6667 10.0001 11.6667C9.54009 11.6667 9.16676 11.2934 9.16676 10.8334V7.50008C9.16676 7.04008 9.54009 6.66675 10.0001 6.66675C10.4601 6.66675 10.8334 7.04008 10.8334 7.50008V10.8334ZM10.0001 14.1667C9.54009 14.1667 9.16676 13.7934 9.16676 13.3334C9.16676 12.8734 9.54009 12.5001 10.0001 12.5001C10.4601 12.5001 10.8334 12.8734 10.8334 13.3334C10.8334 13.7934 10.4601 14.1667 10.0001 14.1667ZM18.8009 13.5859L12.4076 2.98675C11.9084 2.16008 11.0084 1.66675 10.0001 1.66675C8.99175 1.66675 8.09175 2.16008 7.59259 2.98675L1.19926 13.5859C0.725922 14.3717 0.711755 15.3167 1.16176 16.1134C1.64426 16.9692 2.58176 17.5001 3.60676 17.5001H16.3934C17.4184 17.5001 18.3559 16.9692 18.8384 16.1134C19.2884 15.3167 19.2743 14.3717 18.8009 13.5859Z"
        fill="#F6A609"
      />
    </svg>
  );
};

export const BlueAlertTriangleIcon = () => {
  return (
    (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.8334 10.8334C10.8334 11.2934 10.4601 11.6667 10.0001 11.6667C9.54009 11.6667 9.16676 11.2934 9.16676 10.8334V7.50008C9.16676 7.04008 9.54009 6.66675 10.0001 6.66675C10.4601 6.66675 10.8334 7.04008 10.8334 7.50008V10.8334ZM10.0001 14.1667C9.54009 14.1667 9.16676 13.7934 9.16676 13.3334C9.16676 12.8734 9.54009 12.5001 10.0001 12.5001C10.4601 12.5001 10.8334 12.8734 10.8334 13.3334C10.8334 13.7934 10.4601 14.1667 10.0001 14.1667ZM18.8009 13.5859L12.4076 2.98675C11.9084 2.16008 11.0084 1.66675 10.0001 1.66675C8.99175 1.66675 8.09175 2.16008 7.59259 2.98675L1.19926 13.5859C0.725922 14.3717 0.711755 15.3167 1.16176 16.1134C1.64426 16.9692 2.58176 17.5001 3.60676 17.5001H16.3934C17.4184 17.5001 18.3559 16.9692 18.8384 16.1134C19.2884 15.3167 19.2743 14.3717 18.8009 13.5859Z"
          fill="#2445CD"
        />
      </svg>
    ),
    "BlueAlertTriangleIcon"
  );
};

export const ErrorFilledIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0003 2.66669C23.363 2.66669 29.3337 8.63731 29.3337 16C29.3337 23.3627 23.363 29.3334 16.0003 29.3334C8.63762 29.3334 2.66699 23.3627 2.66699 16C2.66699 8.63731 8.63762 2.66669 16.0003 2.66669ZM19.0577 11.0573L16.0003 14.1147L12.943 11.0574L11.0577 12.9427L14.115 16L11.0577 19.0574L12.943 20.9427L16.0003 17.8854L19.0577 20.9427L20.943 19.0574L17.8857 16L20.943 12.9427L19.0577 11.0573Z"
        fill="#E62323"
      />
    </svg>
  );
};

export const InfoIconToast = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M14.0003 20.6667C14.3781 20.6667 14.695 20.5387 14.951 20.2827C15.207 20.0267 15.3345 19.7102 15.3337 19.3334V14C15.3337 13.6222 15.2057 13.3058 14.9497 13.0507C14.6937 12.7956 14.3772 12.6676 14.0003 12.6667C13.6234 12.6658 13.307 12.7938 13.051 13.0507C12.795 13.3076 12.667 13.624 12.667 14V19.3334C12.667 19.7111 12.795 20.028 13.051 20.284C13.307 20.54 13.6234 20.6676 14.0003 20.6667ZM14.0003 10C14.3781 10 14.695 9.87202 14.951 9.61602C15.207 9.36002 15.3345 9.04358 15.3337 8.66669C15.3328 8.2898 15.2048 7.97335 14.9497 7.71735C14.6945 7.46135 14.3781 7.33335 14.0003 7.33335C13.6225 7.33335 13.3061 7.46135 13.051 7.71735C12.7959 7.97335 12.6679 8.2898 12.667 8.66669C12.6661 9.04358 12.7941 9.36047 13.051 9.61736C13.3079 9.87424 13.6243 10.0018 14.0003 10ZM14.0003 27.3334C12.1559 27.3334 10.4226 26.9831 8.80033 26.2827C7.17811 25.5822 5.76699 24.6325 4.56699 23.4334C3.36699 22.2342 2.41722 20.8231 1.71766 19.2C1.01811 17.5769 0.667883 15.8436 0.666994 14C0.666105 12.1565 1.01633 10.4231 1.71766 8.80002C2.41899 7.17691 3.36877 5.7658 4.56699 4.56669C5.76522 3.36758 7.17633 2.4178 8.80033 1.71735C10.4243 1.01691 12.1577 0.666687 14.0003 0.666687C15.843 0.666687 17.5763 1.01691 19.2003 1.71735C20.8243 2.4178 22.2354 3.36758 23.4337 4.56669C24.6319 5.7658 25.5821 7.17691 26.2843 8.80002C26.9866 10.4231 27.3363 12.1565 27.3337 14C27.331 15.8436 26.9808 17.5769 26.283 19.2C25.5852 20.8231 24.6354 22.2342 23.4337 23.4334C22.2319 24.6325 20.8208 25.5827 19.2003 26.284C17.5799 26.9854 15.8465 27.3351 14.0003 27.3334Z"
        fill="#0063C3"
      />
    </svg>
  );
};

export const CheckIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32"
    >
      <path
        fill="#016630"
        fillRule="evenodd"
        d="M27.636 7.752a1.334 1.334 0 0 0-1.885-.055L11.137 21.5l-4.889-4.617a1.334 1.334 0 0 0-1.83 1.938l5.804 5.483a1.333 1.333 0 0 0 1.831 0l15.53-14.666c.535-.506.558-1.35.053-1.885"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

export const ReportAnalyticsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <rect
        width="24"
        height="24"
        fill="url(#pattern0_5522_41268)"
        rx="12"
      ></rect>
      <defs>
        <pattern
          id="pattern0_5522_41268"
          width="1"
          height="1"
          patternContentUnits="objectBoundingBox"
        >
          <use xlinkHref="#image0_5522_41268" transform="scale(.02083)"></use>
        </pattern>
        <image
          xlinkHref="data:image/png;base64,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"
          id="image0_5522_41268"
          width="48"
          height="48"
          preserveAspectRatio="none"
        ></image>
      </defs>
    </svg>
  )
}

export const EmptyStates = {
  EmptyNotificationIcon: () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="110"
        height="99"
        viewBox="0 0 110 99"
        fill="none"
      >
        <path
          d="M41.54 61.6802V62.5602L41.59 62.5901C41.56 62.2901 41.54 61.9902 41.54 61.6802Z"
          stroke="black"
        />
        <path
          d="M55.1494 42V48.48C52.9794 49.15 50.9495 50.04 49.0695 51.12C49.0195 51.15 48.9694 51.18 48.9194 51.21C47.6694 51.94 46.5794 52.7101 45.6494 53.5201V44.9401C47.1094 44.3101 48.6394 43.7501 50.2194 43.2601C51.7994 42.7701 53.4494 42.35 55.1494 42Z"
          fill="#E8E8E8"
          stroke="black"
        />
        <path
          d="M38.3599 49.1504V69.1504C36.8999 70.3504 35.6398 71.6004 34.5798 72.9204C33.5198 74.2404 32.7199 75.6204 32.1799 77.0604C31.8199 78.0504 30.8599 78.6904 29.3099 78.9904C27.7499 79.2804 26.4199 79.1103 25.3199 78.4803L5.12988 66.8204C3.10988 65.6504 2.09984 64.2403 2.08984 62.5903V42.5903C2.09984 44.2403 3.10988 45.6504 5.12988 46.8204L15.1099 52.5803L25.3199 58.4803C26.4199 59.1103 27.7499 59.2804 29.3099 58.9904C30.8599 58.6904 31.8199 58.0504 32.1799 57.0604C32.7199 55.6204 33.5198 54.2404 34.5798 52.9204C35.6398 51.6004 36.8999 50.3504 38.3599 49.1504Z"
          fill="#E8E8E8"
          stroke="#A0A4A8"
        />
        <path
          d="M96.6194 44.8702L96.5094 44.8003L95.5793 44.2703L81.9294 36.3903C80.8894 35.7903 80.3694 35.0903 80.3594 34.2803C80.3594 33.4703 80.8794 32.7603 81.9094 32.1703L86.4794 29.5303L96.4994 23.7402L96.5694 35.3502L96.6194 44.8702Z"
          fill="#E8E8E8"
          stroke="black"
        />
        <path
          d="M107.48 24.0801C107.48 23.3001 107.22 22.5501 106.69 21.8301C106.17 21.1101 105.42 20.4601 104.44 19.9001L78.0999 4.69019C76.0799 3.52019 73.6399 2.94018 70.7699 2.93018C67.8999 2.93018 65.4699 3.50016 63.4599 4.66016L5.07991 38.3701C3.07991 39.5301 2.07992 40.9301 2.08992 42.5901C2.09992 44.2401 3.10996 45.6502 5.12996 46.8202L15.1099 52.5801L25.32 58.4801C26.42 59.1101 27.7499 59.2801 29.3099 58.9901C30.8599 58.6901 31.8199 58.0502 32.1799 57.0602C32.7199 55.6202 33.5199 54.2402 34.5799 52.9202C35.6399 51.6002 36.8999 50.3501 38.3599 49.1501L30.7399 44.7501C30.3799 44.5401 30.0799 44.3202 29.8399 44.0702C29.3999 43.6502 29.1799 43.1701 29.1699 42.6401C29.1699 41.8301 29.6799 41.1202 30.7199 40.5302C31.7499 39.9302 32.9699 39.6301 34.3699 39.6301C35.2699 39.6401 36.0999 39.7601 36.8599 40.0201C37.2699 40.1501 37.6699 40.3302 38.0399 40.5402L45.6499 44.9402C47.1099 44.3102 48.6399 43.7501 50.2199 43.2601C51.7999 42.7701 53.4499 42.3501 55.1499 42.0001L45.3299 36.3301C44.9599 36.1201 44.6499 35.8901 44.4199 35.6501C43.9899 35.2101 43.7699 34.7301 43.7699 34.2101C43.7599 33.4001 44.2799 32.7001 45.3099 32.1001C46.3399 31.5001 47.5599 31.2101 48.9599 31.2101C49.8699 31.2101 50.7099 31.3401 51.4599 31.5901C51.8699 31.7201 52.26 31.9001 52.63 32.1101L67.6799 40.8002C72.2599 40.8502 76.7399 41.3802 81.1399 42.4102C85.0999 43.3402 88.6799 44.6601 91.8999 46.4001C92.2599 46.5801 92.6199 46.7801 92.9699 46.9801C93.5199 47.3001 94.0599 47.6201 94.5799 47.9601C95.0999 48.2901 95.57 48.6202 96 48.9402C96.17 49.0702 96.3399 49.2002 96.5299 49.3002C97.3699 49.8202 98.3999 50.1202 99.6199 50.1902C101.12 50.2802 102.38 50.0202 103.41 49.4302L104.6 48.7401C105.57 48.1801 106.32 47.5402 106.83 46.8202C107.15 46.3702 107.37 45.9102 107.49 45.4402C107.56 45.1502 107.6 44.8602 107.6 44.5702L107.48 24.0801ZM96.51 44.8002L95.5799 44.2701L81.9299 36.3901C80.8899 35.7901 80.3699 35.0902 80.3599 34.2802C80.3599 33.4702 80.8799 32.7602 81.9099 32.1702L86.4799 29.5302L96.5 23.7401L96.57 35.3501L96.6199 44.8701L96.51 44.8002Z"
          stroke="#A0A4A8"
        />
        <path
          d="M85.6694 51.1902C85.3194 50.9902 84.9694 50.7901 84.6094 50.6101C79.8294 48.1101 74.1894 46.8301 67.6794 46.7701H67.3494C62.8694 46.7601 58.7994 47.3301 55.1494 48.4801C52.9794 49.1501 50.9494 50.0401 49.0694 51.1201C49.0194 51.1501 48.9694 51.1801 48.9194 51.2101C47.6694 51.9401 46.5794 52.7101 45.6494 53.5201C45.0394 54.0501 44.4994 54.5902 44.0394 55.1502C42.3494 57.1302 41.5194 59.3002 41.5394 61.6802C41.5394 61.9902 41.5594 62.2901 41.5894 62.5901C41.9294 66.0401 44.1194 69.0602 48.1894 71.6502C48.5094 71.8602 48.8394 72.0602 49.1894 72.2602C54.2694 75.1902 60.3694 76.6602 67.5094 76.6702C69.7794 76.6802 71.9494 76.5301 74.0094 76.2501C75.4994 76.0301 76.9294 75.7402 78.3094 75.3702C81.0094 74.6602 83.5094 73.6402 85.7894 72.3202C86.0894 72.1502 86.3894 71.9702 86.6694 71.7902C89.1994 70.2002 90.9994 68.4401 92.0894 66.5001C92.7294 65.3701 93.1194 64.1802 93.2494 62.9302C93.2994 62.5702 93.3194 62.2101 93.3194 61.8401V61.7701C93.2994 57.6501 90.7494 54.1202 85.6694 51.1902ZM71.7694 60.9801C71.6794 61.2701 71.4594 61.5201 71.0894 61.7301L61.8194 67.0802L60.1394 68.0503C59.6594 68.3303 59.0494 68.4701 58.3194 68.4701C57.5894 68.4701 57.0294 68.3402 56.5494 68.0802C56.5194 68.0702 56.4994 68.0502 56.4794 68.0402C55.9894 67.7602 55.7494 67.4102 55.7494 66.9802C55.7394 66.5602 55.9894 66.2102 56.4694 65.9302L66.5194 60.1301L67.4194 59.6101C67.4994 59.5601 67.5894 59.5202 67.6794 59.4902C68.1094 59.2902 68.6394 59.1903 69.2494 59.1903C69.9794 59.1903 70.5894 59.3301 71.0794 59.6201C71.5694 59.9001 71.8094 60.2502 71.8194 60.6702C71.8194 60.7802 71.8094 60.8801 71.7694 60.9801ZM78.3894 57.5201C77.8994 57.8001 77.2894 57.9403 76.5594 57.9403C75.8294 57.9303 75.2194 57.7902 74.7294 57.5102C74.2394 57.2302 73.9894 56.8702 73.9894 56.4502C73.9894 56.0302 74.2294 55.6802 74.7194 55.4002C75.1994 55.1202 75.8094 54.9801 76.5394 54.9801C77.2694 54.9801 77.8894 55.1202 78.3794 55.4002C78.8594 55.6902 79.1094 56.0401 79.1094 56.4601C79.1094 56.8801 78.8694 57.2401 78.3894 57.5201Z"
          stroke="#A0A4A8"
        />
        <path
          d="M79.1102 56.46C79.1102 56.88 78.8702 57.24 78.3902 57.52C77.9002 57.8 77.2902 57.9401 76.5602 57.9401C75.8302 57.9301 75.2202 57.79 74.7302 57.51C74.2402 57.23 73.9902 56.8701 73.9902 56.4501C73.9902 56.0301 74.2302 55.68 74.7202 55.4C75.2002 55.12 75.8102 54.98 76.5402 54.98C77.2702 54.98 77.8902 55.12 78.3802 55.4C78.8602 55.69 79.1102 56.04 79.1102 56.46Z"
          fill="#E8E8E8"
          stroke="#A0A4A8"
        />
        <path
          d="M107.6 64.5703C107.6 65.3503 107.34 66.1003 106.83 66.8203C106.32 67.5403 105.57 68.1802 104.6 68.7402L103.41 69.4303C102.38 70.0203 101.12 70.2803 99.6197 70.1903C98.1297 70.1003 96.9197 69.6803 95.9997 68.9403C95.5697 68.6203 95.0997 68.2902 94.5797 67.9602C94.1697 67.6902 93.7497 67.4403 93.3197 67.1803V61.7703C93.2997 57.6503 90.7497 54.1203 85.6697 51.1903C85.3197 50.9903 84.9697 50.7902 84.6097 50.6102C79.8297 48.1102 74.1897 46.8303 67.6797 46.7703V40.8003C72.2597 40.8503 76.7396 41.3803 81.1396 42.4103C85.0996 43.3403 88.6797 44.6603 91.8997 46.4003C92.2597 46.5803 92.6197 46.7802 92.9697 46.9802C93.5197 47.3002 94.0597 47.6202 94.5797 47.9602C95.0997 48.2902 95.5697 48.6203 95.9997 48.9403C96.1697 49.0703 96.3397 49.2003 96.5297 49.3003C97.3697 49.8203 98.3997 50.1203 99.6197 50.1903C101.12 50.2803 102.38 50.0203 103.41 49.4303L104.6 48.7402C105.57 48.1802 106.32 47.5403 106.83 46.8203C107.15 46.3703 107.37 45.9103 107.49 45.4403L107.6 64.5703Z"
          fill="#E8E8E8"
          stroke="#A0A4A8"
        />
        <path
          d="M71.8203 60.6704C71.8203 60.7804 71.8102 60.8803 71.7702 60.9803C71.6802 61.2703 71.4603 61.5203 71.0903 61.7303L61.8203 67.0803L60.1402 68.0504C59.6602 68.3304 59.0503 68.4703 58.3203 68.4703C57.5903 68.4703 57.0303 68.3403 56.5503 68.0803C56.5203 68.0703 56.5003 68.0504 56.4803 68.0404C55.9903 67.7604 55.7503 67.4103 55.7503 66.9803C55.7403 66.5603 55.9903 66.2104 56.4703 65.9304L66.5202 60.1303L67.4203 59.6103C67.5003 59.5603 67.5903 59.5203 67.6803 59.4903C68.1103 59.2903 68.6403 59.1904 69.2503 59.1904C69.9803 59.1904 70.5902 59.3303 71.0802 59.6203C71.5702 59.9003 71.8103 60.2504 71.8203 60.6704Z"
          fill="#E8E8E8"
          stroke="#A0A4A8"
        />
        <path
          d="M67.6797 40.8V46.77H67.3497C62.8697 46.76 58.7997 47.33 55.1497 48.48V42L45.3297 36.33C44.9597 36.12 44.6497 35.89 44.4197 35.65C43.9897 35.21 43.7697 34.73 43.7697 34.21C43.7597 33.4 44.2797 32.7 45.3097 32.1C46.3397 31.5 47.5597 31.21 48.9597 31.21C49.8697 31.21 50.7097 31.34 51.4597 31.59C51.8697 31.72 52.2597 31.9 52.6297 32.11L67.6797 40.8Z"
          fill="white"
          stroke="#A0A4A8"
        />
        <path
          d="M93.3201 62.97V81.77C93.3501 85.89 90.83 89.4101 85.79 92.3201C80.74 95.2401 74.6501 96.69 67.5101 96.67C60.3701 96.66 54.2701 95.19 49.1901 92.26C44.1101 89.32 41.56 85.8001 41.54 81.6801V62.5601L41.59 62.59C41.93 66.04 44.1201 69.06 48.1901 71.65C48.5101 71.86 48.8401 72.06 49.1901 72.26C54.2701 75.19 60.3701 76.66 67.5101 76.67C69.7801 76.68 71.9501 76.53 74.0101 76.25C75.5001 76.03 76.9301 75.74 78.3101 75.37C81.0101 74.66 83.51 73.6401 85.79 72.3201C86.09 72.1501 86.39 71.97 86.67 71.79C89.2 70.2 91 68.44 92.09 66.5C92.73 65.37 93.1201 64.1801 93.2501 62.9301L93.3201 62.97Z"
          fill="#E8E8E8"
          stroke="#A0A4A8"
        />
        <path
          d="M45.6499 44.94V53.5199C45.0399 54.0499 44.4999 54.5899 44.0399 55.1499C42.3499 57.1299 41.5199 59.3 41.5399 61.68V62.56L38.3599 60.7299V49.1499L30.7399 44.7499C30.3799 44.5399 30.0799 44.32 29.8399 44.07C29.3999 43.65 29.1799 43.1699 29.1699 42.6399C29.1699 41.8299 29.6799 41.12 30.7199 40.53C31.7499 39.93 32.9699 39.6299 34.3699 39.6299C35.2699 39.6399 36.0999 39.7599 36.8599 40.0199C37.2699 40.1499 37.6699 40.33 38.0399 40.54L45.6499 44.94Z"
          fill="white"
          stroke="#A0A4A8"
        />
      </svg>
    );
  },
  CompanyHouseIcon: () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="104"
        height="112"
        fill="none"
        viewBox="0 0 104 112"
      >
        <path
          fill="url(#paint0_linear_5163_16821)"
          d="M4 44a4 4 0 0 1 4-4h88a4 4 0 0 1 4 4v64a4 4 0 0 1-4 4H8a3.997 3.997 0 0 1-4-4z"
        ></path>
        <path
          fill="url(#paint1_linear_5163_16821)"
          d="M20 68a4 4 0 0 1 4-4h24a4 4 0 0 1 4 4v44H20z"
        ></path>
        <path
          fill="url(#paint2_linear_5163_16821)"
          fillOpacity="0.8"
          d="M60 68a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H64a4 4 0 0 1-4-4z"
        ></path>
        <path
          fill="url(#paint3_linear_5163_16821)"
          d="M44 12V0H24a4 4 0 0 0-2.496.88l-20 16c-.96.76-1.312 1.92-1.44 3.104L0 20v16a20 20 0 0 0 40 0V20l-3.336-.664z"
        ></path>
        <path
          fill="url(#paint4_linear_5163_16821)"
          d="M103.944 19.992c-.12-1.192-.48-2.344-1.44-3.12l-20-16A4 4 0 0 0 80 0H60v12l7.336 7.336L64 20v16a20 20 0 1 0 40 0V20z"
        ></path>
        <path
          fill="url(#paint5_linear_5163_16821)"
          d="m64 0 8 20v16a20 20 0 1 1-40 0V20l8-20z"
        ></path>
        <defs>
          <linearGradient
            id="paint0_linear_5163_16821"
            x1="52"
            x2="52"
            y1="40"
            y2="112"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFBB5C"></stop>
            <stop offset="1" stopColor="#FAB655"></stop>
          </linearGradient>
          <linearGradient
            id="paint1_linear_5163_16821"
            x1="36"
            x2="36"
            y1="64"
            y2="112"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F9A022"></stop>
            <stop offset="1" stopColor="#D06D01"></stop>
          </linearGradient>
          <linearGradient
            id="paint2_linear_5163_16821"
            x1="67.2"
            x2="75.968"
            y1="61.336"
            y2="92.896"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FDFDFD"></stop>
            <stop offset="1" stopColor="#B3E0FF"></stop>
          </linearGradient>
          <linearGradient
            id="paint3_linear_5163_16821"
            x1="22"
            x2="22"
            y1="0"
            y2="56"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F9A022"></stop>
            <stop offset="1" stopColor="#D06D01"></stop>
          </linearGradient>
          <linearGradient
            id="paint4_linear_5163_16821"
            x1="82"
            x2="82"
            y1="0"
            y2="56"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F9A022"></stop>
            <stop offset="1" stopColor="#D06D01"></stop>
          </linearGradient>
          <linearGradient
            id="paint5_linear_5163_16821"
            x1="52"
            x2="52"
            y1="0"
            y2="56"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFBB5C"></stop>
            <stop offset="1" stopColor="#EA9C2C"></stop>
          </linearGradient>
        </defs>
      </svg>
    );
  },
};
